import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  Search,
  MoreHorizontal,
  ChevronsUpDown,
  ChevronLeft,
  ChevronRight,
  X,
  Copy,
  SquareArrowOutUpRight,
  Funnel,
  Pencil,
  PencilLine,
  Plus,
  CircleAlert,
  CircleX,
  ArrowRight,
  ChevronDown,
  Info,
} from "lucide-react";
import { useHistory, useLocation } from "react-router-dom";
import noBrandImage from "../../assets/img/brand/no-brand-img.png";
import emptySearchImg from "../../assets/img/brand/empty-search.png";
import Pagination from "../../components/Pagination";
import SortableHeader from "../../components/SortableHeader";
import SearchBox from "../../components/SearchBox";
import FilterDrawer from "../../components/FilterDrawer";
import { formatDateTime } from "../../utils/formateDate";
import ConfirmDeactivateModal from "../../components/ConfirmDeactivateModal";

// const dummyData = [
//     {
//         id: 101,
//         name: "Samsung S25 Plus",
//         variant: "Silver Shadow, 256 GB",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Unactivated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 1,048.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee SG",
//                 color: "#198754",
//                 platformPrice: "SGD 1,038.00",
//                 erpPrice: "SGD 1,038.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Shopee SG",
//                 color: "#198754",
//                 platformPrice: "SGD 1,188.00",
//                 erpPrice: "SGD 1,188.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada SG",
//                 color: "#FD7E14",
//                 platformPrice: "SGD 1,048.00",
//                 erpPrice: "SGD 1,048.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "TikTok SG",
//                 color: "#DC3545",
//                 platformPrice: "-",
//                 erpPrice: "-",
//                 platformStock: "-",
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     },
//     {
//         id: 102,
//         name: "OnePlus Buds Pro 3",
//         variant: "Sapphire Blue",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Unactivated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 178.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee SG",
//                 color: "#DC3545",
//                 platformPrice: "-",
//                 erpPrice: "-",
//                 platformStock: "-",
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada SG",
//                 color: "#198754",
//                 platformPrice: "SGD 203.00",
//                 erpPrice: "SGD 203.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "TikTok SG",
//                 color: "#198754",
//                 platformPrice: "SGD 178.00",
//                 erpPrice: "SGD 178.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     },
//     {
//         id: 103,
//         name: "OnePlus Buds Pro 3",
//         variant: "Midnight Opus",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Unactivated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 178.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee SG",
//                 color: "#198754",
//                 platformPrice: "SGD 229.00",
//                 erpPrice: "SGD 229.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada SG",
//                 color: "#198754",
//                 platformPrice: "SGD 203.00",
//                 erpPrice: "SGD 203.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "TikTok SG",
//                 color: "#198754",
//                 platformPrice: "SGD 178.00",
//                 erpPrice: "SGD 178.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     },
//     {
//         id: 104,
//         name: "OnePlus Buds Pro 3",
//         variant: "Lunar Radiance",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Unactivated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 178.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee SG",
//                 color: "#198754",
//                 platformPrice: "SGD 229.00",
//                 erpPrice: "SGD 229.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada SG",
//                 color: "#198754",
//                 platformPrice: "SGD 203.00",
//                 erpPrice: "SGD 203.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "TikTok SG",
//                 color: "#198754",
//                 platformPrice: "SGD 178.00",
//                 erpPrice: "SGD 178.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     },
//     {
//         id: 105,
//         name: "iPhone 16 Pro Max",
//         variant: "White Titanium, 512 GB",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Activated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 0.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "TikTok SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     },
//     {
//         id: 106,
//         name: "iPhone 16 Pro Max",
//         variant: "White Titanium, 1 TB",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Activated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 0.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "TikTok SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     },
//     {
//         id: 107,
//         name: "iPhone 16 Pro Max",
//         variant: "White Titanium, 256 GB",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Activated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 0.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "TikTok SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     },
//     {
//         id: 108,
//         name: "iPhone 16 Pro Max",
//         variant: "White Titanium, 512 GB",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Activated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 0.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "TikTok SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     },
//     {
//         id: 109,
//         name: "iPhone 16 Pro Max",
//         variant: "White Titanium, 1 TB",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Activated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 0.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "TikTok SG",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     },
//     {
//         id: 110,
//         name: "iPhone 16 Pro Max",
//         variant: "White Titanium, 256 GB",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Activated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 0.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Website",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     },
//     {
//         id: 111,
//         name: "iPhone 16 Pro Max",
//         variant: "White Titanium, 256 GB",
//         avatar:
//             "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
//         condition: "New",
//         grading: "Activated",
//         status: "Active",
//         iD: "12345",
//         basePrice: "SGD 0.00",
//         erpStock: 10,
//         platforms: [
//             {
//                 name: "Shopee",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Lazada",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             },
//             {
//                 name: "Website",
//                 color: "#198754",
//                 platformPrice: "SGD 0.00",
//                 erpPrice: "SGD 0.00",
//                 platformStock: 10,
//                 lastSync: "2025-01-23 12:30"
//             }
//         ]
//     }
// ];

const dummyData = [];
const dummyDataArchived = [
  {
    id: 101,
    name: "Samsung S25 Plus",
    variant: "Silver Shadow, 256 GB",
    avatar:
      "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
    condition: "New",
    grading: "Unactivated",
    status: "Active",
    iD: "12345",
    basePrice: "SGD 1,048.00",
    erpStock: 10,
    platforms: [
      {
        name: "Shopee SG",
        color: "#198754",
        platformPrice: "SGD 1,038.00",
        erpPrice: "SGD 1,038.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Shopee SG",
        color: "#198754",
        platformPrice: "SGD 1,188.00",
        erpPrice: "SGD 1,188.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Lazada SG",
        color: "#FD7E14",
        platformPrice: "SGD 1,048.00",
        erpPrice: "SGD 1,048.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "TikTok SG",
        color: "#DC3545",
        platformPrice: "-",
        erpPrice: "-",
        platformStock: "-",
        lastSync: "2025-01-23 12:30",
      },
    ],
  },
  {
    id: 102,
    name: "OnePlus Buds Pro 3",
    variant: "Sapphire Blue",
    avatar:
      "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
    condition: "New",
    grading: "Unactivated",
    status: "Active",
    iD: "12345",
    basePrice: "SGD 178.00",
    erpStock: 10,
    platforms: [
      {
        name: "Shopee SG",
        color: "#DC3545",
        platformPrice: "-",
        erpPrice: "-",
        platformStock: "-",
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Lazada SG",
        color: "#198754",
        platformPrice: "SGD 203.00",
        erpPrice: "SGD 203.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "TikTok SG",
        color: "#198754",
        platformPrice: "SGD 178.00",
        erpPrice: "SGD 178.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
    ],
  },
  {
    id: 103,
    name: "OnePlus Buds Pro 3",
    variant: "Midnight Opus",
    avatar:
      "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
    condition: "New",
    grading: "Unactivated",
    status: "Active",
    iD: "12345",
    basePrice: "SGD 178.00",
    erpStock: 10,
    platforms: [
      {
        name: "Shopee SG",
        color: "#198754",
        platformPrice: "SGD 229.00",
        erpPrice: "SGD 229.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Lazada SG",
        color: "#198754",
        platformPrice: "SGD 203.00",
        erpPrice: "SGD 203.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "TikTok SG",
        color: "#198754",
        platformPrice: "SGD 178.00",
        erpPrice: "SGD 178.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
    ],
  },
  {
    id: 104,
    name: "OnePlus Buds Pro 3",
    variant: "Lunar Radiance",
    avatar:
      "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
    condition: "New",
    grading: "Unactivated",
    status: "Active",
    iD: "12345",
    basePrice: "SGD 178.00",
    erpStock: 10,
    platforms: [
      {
        name: "Shopee SG",
        color: "#198754",
        platformPrice: "SGD 229.00",
        erpPrice: "SGD 229.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Lazada SG",
        color: "#198754",
        platformPrice: "SGD 203.00",
        erpPrice: "SGD 203.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "TikTok SG",
        color: "#198754",
        platformPrice: "SGD 178.00",
        erpPrice: "SGD 178.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
    ],
  },
  {
    id: 105,
    name: "iPhone 16 Pro Max",
    variant: "White Titanium, 512 GB",
    avatar:
      "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
    condition: "New",
    grading: "Activated",
    status: "Active",
    iD: "12345",
    basePrice: "SGD 0.00",
    erpStock: 10,
    platforms: [
      {
        name: "Shopee SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Lazada SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "TikTok SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
    ],
  },
  {
    id: 106,
    name: "iPhone 16 Pro Max",
    variant: "White Titanium, 1 TB",
    avatar:
      "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
    condition: "New",
    grading: "Activated",
    status: "Active",
    iD: "12345",
    basePrice: "SGD 0.00",
    erpStock: 10,
    platforms: [
      {
        name: "Shopee SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Lazada SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "TikTok SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
    ],
  },
  {
    id: 107,
    name: "iPhone 16 Pro Max",
    variant: "White Titanium, 256 GB",
    avatar:
      "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
    condition: "New",
    grading: "Activated",
    status: "Active",
    iD: "12345",
    basePrice: "SGD 0.00",
    erpStock: 10,
    platforms: [
      {
        name: "Shopee SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Lazada SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "TikTok SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
    ],
  },
  {
    id: 108,
    name: "iPhone 16 Pro Max",
    variant: "White Titanium, 512 GB",
    avatar:
      "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
    condition: "New",
    grading: "Activated",
    status: "Active",
    iD: "12345",
    basePrice: "SGD 0.00",
    erpStock: 10,
    platforms: [
      {
        name: "Shopee SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Lazada SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "TikTok SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
    ],
  },
  {
    id: 109,
    name: "iPhone 16 Pro Max",
    variant: "White Titanium, 1 TB",
    avatar:
      "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
    condition: "New",
    grading: "Activated",
    status: "Active",
    iD: "12345",
    basePrice: "SGD 0.00",
    erpStock: 10,
    platforms: [
      {
        name: "Shopee SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Lazada SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "TikTok SG",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
    ],
  },
  {
    id: 110,
    name: "iPhone 16 Pro Max",
    variant: "White Titanium, 256 GB",
    avatar:
      "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
    condition: "New",
    grading: "Activated",
    status: "Active",
    iD: "12345",
    basePrice: "SGD 0.00",
    erpStock: 10,
    platforms: [
      {
        name: "Shopee",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Lazada",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
      {
        name: "Website",
        color: "#198754",
        platformPrice: "SGD 0.00",
        erpPrice: "SGD 0.00",
        platformStock: 10,
        lastSync: "2025-01-23 12:30",
      },
    ],
  },
];

// Drawer -> Platform Data tab data
const platformData = [
  {
    id: 1,
    platform: "Shopee SG",
    product_id: "247549566597",
    sku_id: "247549566597",
    last_sync_time: "2025-01-23  12:30",
  },
  {
    id: 2,
    platform: "Shopee SG",
    product_id: "247549566597",
    sku_id: "247549566597",
    last_sync_time: "2025-01-23  12:30",
  },
  {
    id: 3,
    platform: "Lazada SG",
    product_id: "247549566597",
    sku_id: "247549566597",
    last_sync_time: "2025-01-11  12:41 ",
    textColor: "#984C0C", // color for row 3
    iconType: "alert", // will render CircleAlert
  },
  {
    id: 4,
    platform: "TikTok SG",
    product_id: "247549566597",
    sku_id: "247549566597",
    last_sync_time: "(Failed to sync)",
    textColor: "#842029", // color for row 4
    iconType: "x", // will render CircleX
  },
];

const ICON_MAP = {
  alert: CircleAlert,
  x: CircleX,
};

// Drawer -> Platform Data tab data
const pricingData = [
  {
    id: 1,
    platform: "Shopee SG",
    lising_name:
      "Samsung Galaxy S25 + Plus 5G Snapdragon 8 Elite | S24 + Plus 5G | 256GB 512GB | 1 Year Samsung Warranty | SG Local Set",
    sku_name: "S25 Plus 12GB 256GB, Navy",
    platform_price: "SGD 1,113.00",
    erp_price: "SGD 1,113.00",
    platform_stock: "10",
    erp_stock: "10",
  },
  {
    id: 2,
    platform: "Shopee SG",
    lising_name:
      "S25 Ultra 5G | S25 Edge 5G | S25 + S25 Plus 5G | S25 5G | Snapdragon 8 Elite | Android 15 | 1 Year Samsung SG Warranty",
    sku_name: "S25 Plus 12GB 256GB, Navy",
    platform_price: "SGD 1,113.00",
    erp_price: "SGD 1,113.00",
    platform_stock: "10",
    erp_stock: "10",
  },
  {
    id: 3,
    platform: "Lazada SG",
    lising_name:
      "S25 Ultra 5G | S25 Edge 5G | S25 + S25 Plus 5G | S25 5G | Snapdragon 8 Elite | Android 15 | 1 Year Samsung SG Warrant",
    sku_name: "S25 Plus 12GB 256GB, Navy",
    platform_price: "SGD 1,030.00",
    erp_price: "SGD 1,030.00",
    platform_stock: "10",
    erp_stock: "10",
    textColor: "#984C0C", // color for row 3
    iconType: "alert", // will render CircleAlert
  },
  {
    id: 4,
    platform: "TikTok SG",
    lising_name: "(Failed to sync)",
    sku_name: "(Failed to sync)",
    platform_price: "(Failed to sync)",
    erp_price: "(Failed to sync)",
    platform_stock: "-",
    erp_stock: "-",
    textColor: "#842029", // color for row 4
    iconType: "x", // will render CircleX
  },
];

const PAGE_SIZE = 10; // Display all 10 rows on one page

/* ---------- Helper (text color mapping for sync date) ---------- */
function lastSyncTextColorForPlatformColor(color) {
  // if platform color is orange (#FD7E14) -> text #984C0C
  // if red (#DC3545) -> text #842029
  if (!color) return undefined;
  if (color.toLowerCase() === "#fd7e14") return "#984C0C";
  if (color.toLowerCase() === "#dc3545") return "#842029";
  return undefined;
}

// add near top of file
function mappedTextColorForPlatformColor(color) {
  if (!color) return undefined;
  const c = color.toLowerCase();
  if (c === "#fd7e14") return "#984C0C"; // orange => darker text
  if (c === "#dc3545") return "#842029"; // red => darker text
  return undefined;
}

const noImage = "https://via.placeholder.com/28?text=img";

function phMappedTextColorForPlatformColor(color) {
  if (!color) return undefined;
  const c = color.toLowerCase();
  if (c === "#fd7e14") return "#984C0C";
  if (c === "#dc3545") return "#842029";
  return undefined;
}

function phLastSyncTextColorForPlatformColor(color) {
  if (!color) return undefined;
  if (color.toLowerCase() === "#fd7e14") return "#984C0C";
  if (color.toLowerCase() === "#dc3545") return "#842029";
  return undefined;
}

const phDummyPriceHistory = [
  {
    id: 1,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 3,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },
  {
    id: 2,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 1,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },
  {
    id: 3,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 100,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },
  {
    id: 4,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 1,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },
  {
    id: 5,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 1,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },
  {
    id: 6,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 12,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },
  {
    id: 7,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 1,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },
  {
    id: 8,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 23,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },

  {
    id: 9,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 1,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },
  {
    id: 10,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 214,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },
  {
    id: 11,
    time: "2025-01-23 12:30",
    initiator: {
      id: 1,
      brandName: "John Doe",
      avatar: "https://avatar.iran.liara.run/public",
    },
    reason: "Flash Sale", // will show only if present
    changeCount: 5,
    changes: [
      {
        id: "c1",
        stockName: "OnePlus Buds Pro 3",
        variant: "Sapphire Blue",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#DC3545", price: "SGD 0.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
          { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
        ],
        erpPrice: "SGD 178.00",
      },
      {
        id: "c2",
        stockName: "OnePlus Buds Pro 3",
        variant: "Midnight Opus",
        avatar:
          "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false",
        baseBefore: "SGD 0.00",
        baseAfter: "SGD 178.00",
        platforms: [
          { name: "Shopee SG", color: "#198754", price: "SGD 229.00" },
          { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        ],
        erpPrice: "SGD 178.00",
      },
    ],
  },
];

export default function PlatformPricing({
  data = phDummyPriceHistory,
  ...rest
}) {
  // --- Breadcrumbs & React Router ---
  const breadcrumbs = ["Pricing", "Platform Pricing"];
  const history = useHistory();
  const location = useLocation();
  const [deactivateModalOpen, setDeactivateModalOpen] = useState(false);
  const [selectedStockId, setSelectedStockId] = useState(null);

  // --- Tab State ---
  const [activeTab, setActiveTab] = useState("initiate-pricing");
  useEffect(() => {
    const incomingTab = location?.state?.activeTab;
    if (incomingTab) {
      setActiveTab(incomingTab);
      history.replace(location.pathname, {}); // clear state
    }
  }, [location.state, location.pathname, history]);

  // --- Search / Pagination / Selection State ---
  const [searchTerm, setSearchTerm] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [suppressHighlight, setSuppressHighlight] = useState(false);
  const filterButtonRef = useRef(null);
  const [filterPopupOpen, setFilterPopupOpen] = useState(false);

  // --- Drawer / Row State ---
  const [selectedRow, setSelectedRow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerTab, setDrawerTab] = useState(null);
  const drawerRef = useRef(null);

  // --- Filter State ---
  const [filterOpen, setFilterOpen] = useState(false);
  const [tempFilter, setTempFilter] = useState({
    condition: [],
    status: [],
    baseMin: "",
    baseMax: "",
    platforms: [],
    erpMin: "",
    erpMax: "",
  });
  const [appliedFilter, setAppliedFilter] = useState(null);

  // --- Bulk Pricing State ---
  const BULK_PAGE_SIZE = 10;
  const [bulkActive, setBulkActive] = useState(false);
  const [bulkItems, setBulkItems] = useState([]);
  const [bulkPage, setBulkPage] = useState(1);
  const [bulkDropdownOpen, setBulkDropdownOpen] = useState(false);
  const bulkToolbarRef = useRef(null);
  const [showDuplicateWarning, setShowDuplicateWarning] = useState(false);

  // --- Toolbar Dropdown State ---
  const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
  const toolbarRef = useRef(null);
  const [copied, setCopied] = useState(false);

  // --- Per-row Dropdown State ---
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const buttonRefs = useRef({});
  const [filters, setFilters] = useState({
    status: [],
    platforms: [],
    platformPrice: [],
    platformStock: [],
  });

  const [tempValues, setTempValues] = useState({
    status: [],
    platforms: [],
    platformPrice: [],
    platformStock: [],
  });

  // --- Helpers ---
  function parseCurrencyToNumber(str) {
    if (!str) return NaN;
    const m = String(str).replace(/[^\d.-]/g, "");
    return m === "" ? NaN : Number(m.replace(/,/g, ""));
  }

  // --- Condition Options ---
  const CONDITION_OPTIONS = [
    {
      key: "New|Unactivated",
      label: "New — Unactivated",
      bg: "#D1E7DD",
      border: "#198754",
      color: "#198754",
    },
    {
      key: "New|Activated",
      label: "New — Activated",
      bg: "#D1E7DD",
      border: "#198754",
      color: "#198754",
    },
    {
      key: "Used|Pristine",
      label: "Used — Pristine",
      bg: "#FFF3CD",
      border: "#997404",
      color: "#997404",
    },
    {
      key: "Used|Mint",
      label: "Used — Mint",
      bg: "#FFF3CD",
      border: "#997404",
      color: "#997404",
    },
    {
      key: "Used|Satisfactory",
      label: "Used — Satisfactory",
      bg: "#FFF3CD",
      border: "#997404",
      color: "#997404",
    },
  ];

  // --- Derived State (Memoized) ---
  const filterCount = useMemo(() => {
    if (!appliedFilter) return 0;
    let cnt = 0;
    if (appliedFilter.condition?.length) cnt += appliedFilter.condition.length;
    if (appliedFilter.status?.length) cnt += 1;
    if (appliedFilter.baseMin || appliedFilter.baseMax) cnt += 1;
    if (appliedFilter.platforms?.length) cnt += appliedFilter.platforms.length;
    if (appliedFilter.erpMin || appliedFilter.erpMax) cnt += 1;
    return cnt;
  }, [appliedFilter]);

  const filtered = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    // Base search
    const searchFiltered = dummyData.filter((d) => {
      const platformMatch =
        d.platforms?.some((p) => {
          const fields = [
            p.name,
            p.platformPrice,
            p.erpPrice,
            p.platformStock,
            p.erpStock,
            p.lastSync,
          ];
          return fields.some((f) =>
            String(f ?? "")
              .toLowerCase()
              .includes(term)
          );
        }) || false;

      const rowErpMatch = String(d.erpStock ?? "")
        .toLowerCase()
        .includes(term);

      const matchesSearch =
        term === "" ||
        String(d.name ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.variant ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.iD ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.basePrice ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.status ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.condition ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.grading ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.brand ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.category ?? "")
          .toLowerCase()
          .includes(term) ||
        platformMatch ||
        rowErpMatch;

      return matchesSearch;
    });

    // If no applied filters
    if (!appliedFilter) return searchFiltered;

    // Check row against filters
    function matchesApplied(d) {
      if (appliedFilter?.condition?.length) {
        const selectedKeys = appliedFilter.condition;
        const rowKey = `${String(d.condition ?? "").trim()}|${String(
          d.grading ?? ""
        ).trim()}`;
        const usesCombinedKeys = selectedKeys.some(
          (s) => typeof s === "string" && s.includes("|")
        );
        if (usesCombinedKeys) {
          if (!selectedKeys.includes(rowKey)) return false;
        } else {
          if (!selectedKeys.includes(String(d.condition ?? ""))) return false;
        }
      }
      if (appliedFilter?.status?.length) {
        const selected = appliedFilter.status.map((s) => s.toLowerCase());
        if (!selected.includes(String(d.status ?? "").toLowerCase()))
          return false;
      }
      const baseNum = parseCurrencyToNumber(d.basePrice);
      if (appliedFilter.baseMin) {
        const min = Number(appliedFilter.baseMin);
        if (!Number.isNaN(min) && (Number.isNaN(baseNum) || baseNum < min))
          return false;
      }
      if (appliedFilter.baseMax) {
        const max = Number(appliedFilter.baseMax);
        if (!Number.isNaN(max) && (Number.isNaN(baseNum) || baseNum > max))
          return false;
      }
      if (appliedFilter.platforms?.length) {
        const has = d.platforms?.some((p) =>
          appliedFilter.platforms.includes(p.name)
        );
        if (!has) return false;
      }
      const erp = Number(d.erpStock ?? NaN);
      if (appliedFilter.erpMin) {
        const minE = Number(appliedFilter.erpMin);
        if (!Number.isNaN(minE) && (Number.isNaN(erp) || erp < minE))
          return false;
      }
      if (appliedFilter.erpMax) {
        const maxE = Number(appliedFilter.erpMax);
        if (!Number.isNaN(maxE) && (Number.isNaN(erp) || erp > maxE))
          return false;
      }
      return true;
    }

    return searchFiltered.filter((d) => matchesApplied(d));
  }, [searchTerm, appliedFilter]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const pageData = filtered.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  const selectedRows = useMemo(
    () => dummyData.filter((d) => selectedIds.includes(d.id)),
    [selectedIds]
  );

  // --- Selection Handlers ---
  const toggleSelect = (id) => {
    setSelectedIds((ids) => {
      const includes = ids.includes(id);
      const next = includes ? ids.filter((x) => x !== id) : [...ids, id];
      setSuppressHighlight(false);
      return next;
    });
  };
  const handleDeactivateStock = (stockId) => {
    console.log("Activate / Deactivate stock id:", stockId);

    // 👇 yahan aapki API call aayegi
    // dispatch(deactivateStock(stockId))
  };

  const toggleAll = () => {
    setSelectedIds((prev) => {
      const allOnPage = pageData.map((d) => d.id);
      const alreadyAllSelected =
        allOnPage.length > 0 && allOnPage.every((id) => prev.includes(id));
      const next = alreadyAllSelected
        ? prev.filter((id) => !allOnPage.includes(id))
        : [...new Set([...prev, ...allOnPage])];
      setSuppressHighlight(false);
      return next;
    });
  };
  const clearSelection = () => {
    setSelectedIds([]);
    setBulkDropdownOpen(false);
    setBulkActive(false);
    setBulkItems([]);
  };
  const clearCheckedOnly = () => setSelectedIds([]);

  // --- Bulk Pricing Handlers ---
  useEffect(() => {
    const pages = Math.max(1, Math.ceil(bulkItems.length / BULK_PAGE_SIZE));
    if (bulkPage > pages) setBulkPage(1);
  }, [bulkItems, bulkPage]);

  const handleAddToBulkPricing = () => {
    if (selectedIds.length === 0) return;
    setBulkActive(true);
    setBulkItems((prev) => {
      const alreadyInBulk = selectedIds.filter((id) => prev.includes(id));
      const newOnes = selectedIds.filter((id) => !prev.includes(id));
      if (alreadyInBulk.length > 0) {
        setShowDuplicateWarning(true);
        setTimeout(() => setShowDuplicateWarning(false), 4000);
      }
      return [...prev, ...newOnes];
    });
    setBulkDropdownOpen(true);
    setSelectedIds([]);
    const toolbarEl = bulkToolbarRef.current;
    if (toolbarEl)
      toolbarEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
  };
  const removeBulkItem = (id) => {
    setBulkItems((prev) => {
      const next = prev.filter((x) => x !== id);
      if (next.length === 0) {
        setBulkDropdownOpen(false);
        setBulkActive(false);
      }
      return next;
    });
    setSelectedIds((prev) => prev.filter((x) => x !== id));
  };

  // --- Row / Drawer Handlers ---
  const onRowClick = (row) => {
    setSelectedRow(row);
    setDrawerTab("entity-info");
    setDrawerOpen(true);
  };
  useEffect(() => {
    function handleClickOutsideDrawer(event) {
      if (
        drawerOpen &&
        drawerRef.current &&
        !drawerRef.current.contains(event.target)
      ) {
        setDrawerOpen(false);
        setSelectedRow(null);
        setSelectedIds((ids) =>
          selectedRow ? ids.filter((id) => id !== selectedRow.id) : ids
        );
      }
    }
    document.addEventListener("mousedown", handleClickOutsideDrawer);
    return () =>
      document.removeEventListener("mousedown", handleClickOutsideDrawer);
  }, [drawerOpen, selectedRow]);

  // --- Per-row Dropdown Handlers ---
  const toggleDropdown = (id) => {
    if (dropdownOpenId === id) {
      setDropdownOpenId(null);
      return;
    }
    const btn = buttonRefs.current[id];
    if (btn) {
      const rect = btn.getBoundingClientRect();
      const dropdownWidth = 170;
      const dropdownHeight = 150;
      let left = rect.left + window.scrollX + rect.width - dropdownWidth;
      if (left < window.scrollX + 8) left = window.scrollX + 8;
      let top = rect.bottom + window.scrollY;
      if (top + dropdownHeight > window.scrollY + window.innerHeight) {
        top = rect.top + window.scrollY - dropdownHeight;
      }
      setDropdownPosition({ top, left });
    }
    setDropdownOpenId(id);
  };
  useEffect(() => {
    function handleClickOutside(e) {
      if (
        dropdownOpenId !== null &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !buttonRefs.current[dropdownOpenId]?.contains(e.target)
      ) {
        setDropdownOpenId(null);
      }
    }
    if (dropdownOpenId !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownOpenId]);

  // --- Bulk Dropdown Outside Click ---
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        bulkToolbarRef.current &&
        !bulkToolbarRef.current.contains(e.target)
      ) {
        setBulkDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // --- Toolbar Dropdown Outside Click ---
  const toggleToolbarDropdown = () => setToolbarDropdownOpen((prev) => !prev);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (toolbarRef.current && !toolbarRef.current.contains(e.target)) {
        setToolbarDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // --- Visible Rows (Tabs) ---
  const visiblePlatformRows = useMemo(() => platformData, [platformData]);
  const visiblePricingRows = useMemo(() => pricingData, [pricingData]);

  // Stock Instance Drawer table action column dropdown
  const tableRef = useRef();

  /* ---------- Archived listing state & handlers (rename-safe) ---------- */
  const [searchTermArchived, setSearchTermArchived] = useState("");
  const [currentPageArchived, setCurrentPageArchived] = useState(1);
  const [selectedIdsArchived, setSelectedIdsArchived] = useState([]);
  const [statusFilterArchived, setStatusFilterArchived] = useState("");
  const [suppressHighlightArchived, setSuppressHighlightArchived] =
    useState(false);

  // Row / Drawer / Modal states for archived
  const [selectedRowArchived, setSelectedRowArchived] = useState(null);
  const [drawerOpenArchived, setDrawerOpenArchived] = useState(false);
  const [drawerTabArchived, setDrawerTabArchived] = useState(null);

  // Refs for archived UI
  const dropdownRefArchived = useRef(null);
  const buttonRefsArchived = useRef({});
  const drawerRefArchived = useRef(null);
  const toolbarRefArchived = useRef(null);
  const tableRefArchived = useRef(null);

  // Dropdown positioning state for archived
  const [dropdownPositionArchived, setDropdownPositionArchived] = useState({
    top: 0,
    left: 0,
  });

  // Dropdown / toolbar state for archived
  const [dropdownOpenIdArchived, setDropdownOpenIdArchived] = useState(null);
  const [toolbarDropdownOpenArchived, setToolbarDropdownOpenArchived] =
    useState(false);

  // actually applied filters (used by the list)
  const [appliedFilterArchived, setAppliedFilterArchived] = useState(null);

  /* ---------- Filtered list & pagination for archived ---------- */
  const filteredArchived = useMemo(() => {
    const term = searchTermArchived.trim().toLowerCase();

    // 1) base search (same behaviour as before)
    const searchFiltered = (dummyDataArchived || []).filter((d) => {
      const platformMatch =
        d.platforms?.some((p) => {
          const fields = [
            p.name,
            p.platformPrice,
            p.erpPrice,
            p.platformStock,
            p.erpStock,
            p.lastSync,
          ];
          return fields.some((f) =>
            String(f ?? "")
              .toLowerCase()
              .includes(term)
          );
        }) || false;

      const rowErpMatch = String(d.erpStock ?? "")
        .toLowerCase()
        .includes(term);

      const matchesSearch =
        term === "" ||
        String(d.name ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.variant ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.iD ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.basePrice ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.status ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.condition ?? "")
          .toLowerCase()
          .includes(term) ||
        String(d.grading ?? "")
          .toLowerCase()
          .includes(term) ||
        platformMatch ||
        rowErpMatch;

      return matchesSearch;
    });

    // 2) if no applied filters, return searchFiltered
    if (!appliedFilterArchived) return searchFiltered;

    // helper to test a row against applied filters
    function matchesApplied(d) {
      // Condition: combined key "Condition|Grading" OR legacy plain condition
      if (appliedFilterArchived?.condition?.length) {
        const selectedKeys = appliedFilterArchived.condition;
        const rowKey = `${String(d.condition ?? "").trim()}|${String(
          d.grading ?? ""
        ).trim()}`;
        const usesCombinedKeys = selectedKeys.some(
          (s) => typeof s === "string" && s.includes("|")
        );
        if (usesCombinedKeys) {
          if (!selectedKeys.includes(rowKey)) return false;
        } else {
          if (!selectedKeys.includes(String(d.condition ?? ""))) return false;
        }
      }

      // Status array (allow Active, Inactive, both or none)
      if (appliedFilterArchived?.status?.length) {
        const selected = appliedFilterArchived.status.map((s) =>
          String(s).toLowerCase()
        );
        if (!selected.includes(String(d.status ?? "").toLowerCase()))
          return false;
      }

      // Base price min/max
      const baseNum = parseCurrencyToNumber(d.basePrice);
      if (appliedFilterArchived.baseMin) {
        const min = Number(appliedFilterArchived.baseMin);
        if (!Number.isNaN(min) && (Number.isNaN(baseNum) || baseNum < min))
          return false;
      }
      if (appliedFilterArchived.baseMax) {
        const max = Number(appliedFilterArchived.baseMax);
        if (!Number.isNaN(max) && (Number.isNaN(baseNum) || baseNum > max))
          return false;
      }

      // Platforms (if any selected, require row to have at least one)
      if (appliedFilterArchived.platforms?.length) {
        const has = d.platforms?.some((p) =>
          appliedFilterArchived.platforms.includes(p.name)
        );
        if (!has) return false;
      }

      // ERP stock min/max
      const erp = Number(d.erpStock ?? NaN);
      if (appliedFilterArchived.erpMin) {
        const minE = Number(appliedFilterArchived.erpMin);
        if (!Number.isNaN(minE) && (Number.isNaN(erp) || erp < minE))
          return false;
      }
      if (appliedFilterArchived.erpMax) {
        const maxE = Number(appliedFilterArchived.erpMax);
        if (!Number.isNaN(maxE) && (Number.isNaN(erp) || erp > maxE))
          return false;
      }

      return true;
    }

    return searchFiltered.filter((d) => matchesApplied(d));
  }, [searchTermArchived, appliedFilterArchived, dummyDataArchived]);

  const totalPagesArchived = Math.max(
    1,
    Math.ceil(filteredArchived.length / PAGE_SIZE)
  );
  const pageDataArchived = filteredArchived.slice(
    (currentPageArchived - 1) * PAGE_SIZE,
    currentPageArchived * PAGE_SIZE
  );

  /* ---------- Selection handlers for archived ---------- */
  const toggleSelectArchived = (id) => {
    setSelectedIdsArchived((ids) => {
      const includes = ids.includes(id);
      const next = includes ? ids.filter((x) => x !== id) : [...ids, id];
      setSuppressHighlightArchived(false);
      return next;
    });
  };

  const toggleAllArchived = () => {
    setSelectedIdsArchived((prev) => {
      const allOnPage = pageDataArchived.map((d) => d.id);
      const alreadyAllSelected =
        allOnPage.length > 0 && allOnPage.every((id) => prev.includes(id));
      const next = alreadyAllSelected
        ? prev.filter((id) => !allOnPage.includes(id))
        : [...new Set([...prev, ...allOnPage])];
      setSuppressHighlightArchived(false);
      return next;
    });
  };

  /* ---------- Row click / drawer open for archived ---------- */
  const onRowClickArchived = (row) => {
    setSelectedRowArchived(row);
    setDrawerTabArchived("entity-info");
    setDrawerOpenArchived(true);
  };

  /* ---------- Click outside effects for archived drawer & toolbar ---------- */
  useEffect(() => {
    function handleClickOutsideDrawerArchived(event) {
      if (
        drawerOpenArchived &&
        drawerRefArchived.current &&
        !drawerRefArchived.current.contains(event.target)
      ) {
        setDrawerOpenArchived(false);
        setSelectedRowArchived(null);
        setSelectedIdsArchived((ids) =>
          selectedRowArchived
            ? ids.filter((id) => id !== selectedRowArchived.id)
            : ids
        );
      }
    }
    document.addEventListener("mousedown", handleClickOutsideDrawerArchived);
    return () =>
      document.removeEventListener(
        "mousedown",
        handleClickOutsideDrawerArchived
      );
  }, [drawerOpenArchived, selectedRowArchived]);

  useEffect(() => {
    function handleClickOutsideArchived(event) {
      if (
        dropdownOpenIdArchived !== null &&
        dropdownRefArchived.current &&
        !dropdownRefArchived.current.contains(event.target) &&
        !buttonRefsArchived.current[dropdownOpenIdArchived]?.contains(
          event.target
        )
      ) {
        setDropdownOpenIdArchived(null);
      }
    }
    if (dropdownOpenIdArchived !== null) {
      document.addEventListener("mousedown", handleClickOutsideArchived);
    }
    return () =>
      document.removeEventListener("mousedown", handleClickOutsideArchived);
  }, [dropdownOpenIdArchived]);

  useEffect(() => {
    const handleClickOutsideToolbarArchived = (e) => {
      if (
        toolbarRefArchived.current &&
        !toolbarRefArchived.current.contains(e.target)
      ) {
        setToolbarDropdownOpenArchived(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutsideToolbarArchived);
    return () =>
      document.removeEventListener(
        "mousedown",
        handleClickOutsideToolbarArchived
      );
  }, []);

  /* ---------- Dropdown toggle & positioning for archived ---------- */
  const toggleDropdownArchived = (id) => {
    if (dropdownOpenIdArchived === id) {
      setDropdownOpenIdArchived(null);
      return;
    }

    const btn = buttonRefsArchived.current[id];
    if (btn) {
      const rect = btn.getBoundingClientRect();
      const dropdownWidth = 170;
      const dropdownHeight = 150;

      let left = rect.left + window.scrollX + rect.width - dropdownWidth;
      if (left < window.scrollX + 8) left = window.scrollX + 8;

      let top = rect.bottom + window.scrollY;
      if (top + dropdownHeight > window.scrollY + window.innerHeight) {
        top = rect.top + window.scrollY - dropdownHeight;
      }

      setDropdownPositionArchived({ top, left });
    }
    setDropdownOpenIdArchived(id);
  };

  const toggleToolbarDropdownArchived = () => {
    setToolbarDropdownOpenArchived((prev) => !prev);
  };

  //Archieve modal start here
  const archivedRef = useRef(null);
  const [archivedModalOpen, setArchivedModalOpen] = useState(false);
  const handleArchivedConfirm = () => {
    setArchivedModalOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (archivedRef.current && !archivedRef.current.contains(event.target)) {
        setArchivedModalOpen(false);
      }
    }

    if (archivedModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [archivedModalOpen]);

  //Save Modal start here
  const saveRef = useRef(null);
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const handleSaveConfirm = () => {
    setSaveModalOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (saveRef.current && !saveRef.current.contains(event.target)) {
        setSaveModalOpen(false);
      }
    }

    if (saveModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [saveModalOpen]);

  // ph-prefixed state to avoid collisions
  const [phSearchTerm, setPhSearchTerm] = useState("");
  const [phCurrentPage, setPhCurrentPage] = useState(1);

  const [phSelectedRow, setPhSelectedRow] = useState(null);
  const [phDrawerOpen, setPhDrawerOpen] = useState(false);
  const [phDrawerTab, setPhDrawerTab] = useState("overview");
  const phDrawerRef = useRef(null);

  // filter logic — search across time, initiator brand, changeCount, and changes' name/variant/platform
  const phFiltered = useMemo(() => {
    const term = phSearchTerm.trim().toLowerCase();
    return (data || []).filter((r) => {
      if (!term) return true;
      return (
        String(r.time ?? "")
          .toLowerCase()
          .includes(term) ||
        String(r.initiator?.brandName ?? "")
          .toLowerCase()
          .includes(term) ||
        String(r.changeCount ?? "")
          .toLowerCase()
          .includes(term) ||
        String(r.reason ?? "")
          .toLowerCase()
          .includes(term) ||
        (r.changes || []).some(
          (c) =>
            String(c.stockName ?? "")
              .toLowerCase()
              .includes(term) ||
            String(c.variant ?? "")
              .toLowerCase()
              .includes(term) ||
            (c.platforms || []).some((p) =>
              String(p.name ?? "")
                .toLowerCase()
                .includes(term)
            )
        )
      );
    });
  }, [phSearchTerm, data]);

  const phTotalPages = Math.max(1, Math.ceil(phFiltered.length / PAGE_SIZE));
  const phPageData = phFiltered.slice(
    (phCurrentPage - 1) * PAGE_SIZE,
    phCurrentPage * PAGE_SIZE
  );

  // close drawer on outside click (same pattern as your archived tab)
  useEffect(() => {
    function handleClickOutside(e) {
      if (
        phDrawerOpen &&
        phDrawerRef.current &&
        !phDrawerRef.current.contains(e.target)
      ) {
        setPhDrawerOpen(false);
        setPhSelectedRow(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [phDrawerOpen]);

  const phOnRowClick = (row) => {
    setPhSelectedRow(row);
    setPhDrawerTab("overview"); // first tab open
    setPhDrawerOpen(true);
  };

  /** tiny placeholder if noImage isn’t defined */
  const safeNoImage =
    "https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false";

  /** PricePill */
  const PricePill = ({ value, variant = "default" }) => (
    <span
      style={{
        borderRadius: 99,
        padding: "3px 10px",
        fontSize: 14,
        lineHeight: "15px",
        border: `1px solid ${variant === "danger" ? "#842029" : "#6C757D"}`,
        display: "inline-block",
        minWidth: 90,
        textAlign: "center",
        fontWeight: 600,
        background: variant === "danger" ? "#F8D7DA" : "#ffffff",
        color: variant === "danger" ? "#842029" : "#6C757D",
      }}
    >
      {value}
    </span>
  );

  /** Arrow */
  const Arrow = (props) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor" // <── use currentColor here
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );

  /** PlatformList */
  const PlatformList = ({ platforms = [] }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      {platforms.map((p, i) => {
        const isDanger = p.color.toLowerCase() === "#842029";
        return (
          <div
            key={i}
            style={{ display: "flex", alignItems: "center", gap: "6px" }}
          >
            <span style={{ color: p.color }}>●</span>
            <span style={isDanger ? { color: p.color } : {}}>{p.name}</span>
            <span
              style={{
                marginLeft: "auto",
                ...(isDanger ? { color: p.color } : {}),
              }}
            >
              {p.price}
            </span>
          </div>
        );
      })}
    </div>
  );

  /** ErpList */
  const ErpList = ({ erp = [] }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {erp.map((e, i) => {
        const isDanger = e.color.toLowerCase() === "#842029";
        return (
          <div
            key={i}
            style={{ display: "flex", alignItems: "center", gap: "6px" }}
          >
            <span
              style={{
                marginLeft: "auto",
                ...(isDanger ? { color: e.color } : {}),
              }}
            >
              {e.current}
            </span>
            <Arrow style={{ color: isDanger ? e.color : undefined }} />
            <PricePill
              value={e.target}
              variant={isDanger ? "danger" : "default"}
            />
          </div>
        );
      })}
    </div>
  );

  /** sample data (matches figma) */
  const sampleRows = [
    {
      id: 1,
      avatar: safeNoImage,
      name: "OnePlus Buds Pro 3",
      variant: "Sapphire Blue",
      condition: "New",
      grading: "Unactivated",
      baseCurrent: "SGD 0.00",
      baseTarget: "SGD 178.00",
      platforms: [
        { name: "Shopee SG", color: "#842029", price: "SGD 0.00" },
        { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
      ],
      erp: [
        {
          name: "Shopee SG",
          color: "#842029",
          current: "SGD 0.00",
          target: "SGD 178.00",
        },
        {
          name: "Lazada SG",
          color: "#198754",
          current: "SGD 0.00",
          target: "SGD 178.00",
        },
        {
          name: "TikTok SG",
          color: "#198754",
          current: "SGD 0.00",
          target: "SGD 178.00",
        },
      ],
    },
    {
      id: 2,
      avatar: safeNoImage,
      name: "OnePlus Buds Pro 3",
      variant: "Midnight Opus",
      condition: "New",
      grading: "Unactivated",
      baseCurrent: "SGD 0.00",
      baseTarget: "SGD 178.00",
      platforms: [
        { name: "Shopee SG", color: "#198754", price: "SGD 0.00" },
        { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
      ],
      erp: [
        {
          name: "Shopee SG",
          color: "#198754",
          current: "SGD 0.00",
          target: "SGD 178.00",
        },
        {
          name: "Lazada SG",
          color: "#198754",
          current: "SGD 0.00",
          target: "SGD 178.00",
        },
        {
          name: "TikTok SG",
          color: "#198754",
          current: "SGD 0.00",
          target: "SGD 178.00",
        },
      ],
    },
    {
      id: 3,
      avatar: safeNoImage,
      name: "OnePlus Buds Pro 3",
      variant: "Lunar Radiance",
      condition: "New",
      grading: "Unactivated",
      baseCurrent: "SGD 0.00",
      baseTarget: "SGD 178.00",
      platforms: [
        { name: "Shopee SG", color: "#198754", price: "SGD 0.00" },
        { name: "Lazada SG", color: "#198754", price: "SGD 203.00" },
        { name: "TikTok SG", color: "#198754", price: "SGD 178.00" },
      ],
      erp: [
        {
          name: "Shopee SG",
          color: "#198754",
          current: "SGD 0.00",
          target: "SGD 178.00",
        },
        {
          name: "Lazada SG",
          color: "#198754",
          current: "SGD 0.00",
          target: "SGD 178.00",
        },
        {
          name: "TikTok SG",
          color: "#198754",
          current: "SGD 0.00",
          target: "SGD 178.00",
        },
      ],
    },
  ];

  // ---------- ADD: archived filter UI state & helpers ----------
  const [filterOpenArchived, setFilterOpenArchived] = useState(false);

  // temporary form state shown in drawer (not applied until user clicks Filter)
  const [tempFilterArchived, setTempFilterArchived] = useState({
    condition: [], // combined keys like "New|Unactivated"
    status: [], // array of statuses: ["Active","Inactive"]
    baseMin: "",
    baseMax: "",
    platforms: [], // e.g. ["Shopee SG"]
    erpMin: "",
    erpMax: "",
  });

  // count of active filters for badge
  const filterCountArchived = useMemo(() => {
    if (!appliedFilterArchived) return 0;
    let cnt = 0;
    if (appliedFilterArchived.condition?.length)
      cnt += appliedFilterArchived.condition.length;
    if (appliedFilterArchived.status?.length)
      cnt += appliedFilterArchived.status.length;
    if (appliedFilterArchived.baseMin || appliedFilterArchived.baseMax)
      cnt += 1;
    if (appliedFilterArchived.platforms?.length)
      cnt += appliedFilterArchived.platforms.length;
    if (appliedFilterArchived.erpMin || appliedFilterArchived.erpMax) cnt += 1;
    return cnt;
  }, [appliedFilterArchived]);

  // Combined condition options used in drawer
  const CONDITION_OPTIONS_ARCHIVED = [
    "New|Unactivated",
    "New|Activated",
    "Used|Pristine",
    "Used|Mint",
    "Used|Satisfactory",
  ];

  const FilterActiveIcon = () => (
    <svg
      style={{ margin: 0 }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6325 6.44444C20.7252 6.24267 20.7746 6.02858 20.8107 5.74756C21.0354 4.00089 21.1478 3.12756 21.6356 2.56378C20.1234 2 19.2177 2 17.4063 2H4.59369C2.78227 2 1.87655 2 1.36439 2.56378C0.852232 3.12756 0.964572 4.00089 1.18925 5.74756C1.25487 6.25766 1.36399 6.54725 1.69704 6.94296C2.77293 8.22128 4.74334 10.4951 7.50829 12.5623C7.76095 12.7512 7.92676 13.0599 7.95475 13.4016C8.26623 17.2071 8.55159 19.8068 8.70309 21.0865C8.78256 21.7577 9.52673 22.274 10.14 21.8404C11.1702 21.1118 13.0947 20.2952 13.349 18.938C13.4692 18.2964 13.6451 17.1765 13.8437 15.3333"
        stroke="#0D6EFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_4516_4830)">
        <path
          d="M22.8125 11C22.8125 14.2102 20.2102 16.8125 17 16.8125C13.7898 16.8125 11.1875 14.2102 11.1875 11C11.1875 7.78987 13.7898 5.18753 17 5.18753C20.2102 5.18753 22.8125 7.78987 22.8125 11ZM16.3277 14.0777L20.6402 9.7652C20.7866 9.61877 20.7866 9.38132 20.6402 9.23488L20.1099 8.70456C19.9634 9.5581 19.726 9.5581 19.5795 8.70456L16.0625 12.2215L14.4205 10.5795C14.2741 10.4331 14.0366 10.4331 13.8901 10.5795L13.3598 11.1099C13.2134 11.2563 13.2134 11.4937 13.3598 11.6402L15.7973 14.0777C15.9438 14.2241 16.1812 14.2241 16.3277 14.0777Z"
          fill="#0D6EFD"
        />
      </g>
      <defs>
        <clipPath id="clip0_4516_4830">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(11 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  const FilterInactiveIcon = () => (
    <svg
      style={{ margin: 0 }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333"
        stroke="#ced1d3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445"
        stroke="#ced1d3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const filtersApplied =
    (filters.status?.length || 0) > 0 ||
    (filters.brand?.length || 0) > 0 ||
    (filters.category?.length || 0) > 0 ||
    (filters.type?.length || 0) > 0;

  const isInitialTableEmpty = pageData?.length === 0;

  const sections = [
    {
      label: "Status",
      type: "checkbox",
      key: "status",
      options: ["Active", "Inactive"],
    },
    {
      label: "Platforms",
      type: "list",
      key: "platforms",
      // data: platformsData, // <-- array of platforms
    },
    {
      label: "Platform Price",
      type: "range",
      key: "platformPrice",
      // data: platformPriceOptions, // <-- eg: ["Free", "Paid"]
    },
    {
      label: "Platform Stock",
      type: "rangePlain",
      key: "platformStock",
      // data: platformStockOptions, // <-- eg: ["In Stock", "Out of Stock"]
    },
  ];

  const handleCopy = async (textToCopy) => {
    if (!textToCopy) {
      console.error("No text to copy");
      // alert('Failed to copy: No text available.');
      return;
    }

    // Use Clipboard API if available and secure
    if (
      window.isSecureContext &&
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === "function"
    ) {
      try {
        await navigator.clipboard.writeText(textToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
      } catch (err) {
        console.error("Clipboard API failed:", err);
        fallbackCopyTextToClipboard(textToCopy);
      }
    } else {
      console.warn(
        "Clipboard API not available or not in secure context, using fallback"
      );
      fallbackCopyTextToClipboard(textToCopy);
    }
  };
  const fallbackCopyTextToClipboard = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } else {
        console.error("Fallback copy failed");
        alert("Failed to copy text. Please copy manually.");
      }
    } catch (err) {
      console.error("Fallback copy error:", err);
      alert("Failed to copy text. Please copy manually.");
    }
  };
  return (
    <div className="company-body new-look stock-wrap bg-checkbox">
      {/* Breadcrumbs */}
      <div className="breadcrumb">
        {breadcrumbs.map((crumb, index) => (
          <span key={index} className="breadcrumb-item">
            {crumb}
            {index !== breadcrumbs.length - 1}
          </span>
        ))}
      </div>

      <div className="employee-tabs-container">
        {/* ─── Tab Buttons ─── */}
        <div className="tabs">
          <button
            // Apply the "active" class only when this tab is selected
            className={`tab ${
              activeTab === "initiate-pricing" ? "active" : ""
            }`}
            onClick={() => setActiveTab("initiate-pricing")}
          >
            Initiate Pricing
          </button>

          {/* <button
                        // Apply the "active" class only when this tab is selected
                        className={`tab ${activeTab === 'price-history' ? 'active' : ''
                            }`}
                        onClick={() => setActiveTab('price-history')}
                    >
                        Price History
                    </button> */}

          <button
            className={`tab ${activeTab === "pricing-history" ? "active" : ""}`}
            onClick={() => setActiveTab("pricing-history")}
          >
            Pricing History
          </button>
        </div>

        {/* ─── Tab Contents ─── */}
        {activeTab === "initiate-pricing" && (
          <div className="tab-content" id="listing-content">
            {/* Stock List Card */}
            <div className="info-section">
              <div className="info-card" style={{ overflow: "unset" }}>
                {/* <div className="info-header" style={{ borderRadius: '12px 12px 0 0' }}>
                                    <h4 className="info-title">Listing</h4>
                                </div> */}

                <div className="entities-tab">
                  {/* Toolbar: Search + Filter on left; Edit/Plus on right */}
                  <div className="toolbar">
                    <div className="toolbar-left">
                      <SearchBox
                        searchInput={searchInput}
                        setSearchInput={setSearchInput}
                        setSearchTerm={setSearchTerm}
                        setCurrentPage={setCurrentPage}
                        disabled={isInitialTableEmpty}
                      />

                      <div style={{ position: "relative" }}>
                        <button
                          ref={filterButtonRef}
                          className={`icon-btn p-2 filter-btn ${
                            filtersApplied ? "applied" : ""
                          }`}
                          onClick={() =>
                            !isInitialTableEmpty &&
                            setFilterPopupOpen(!filterPopupOpen)
                          }
                          disabled={isInitialTableEmpty}
                          style={{
                            border: filtersApplied
                              ? "1px solid #2C7BE5"
                              : "1px solid #ced1d3",
                            borderWidth: "2px",
                            color: filtersApplied ? "#2C7BE5" : "#6C757D",

                            background: isInitialTableEmpty
                              ? "#E9ECEF" // disabled background
                              : filtersApplied
                              ? "#CFE2FF" // active filter
                              : "#FFFFFF", // normal

                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            opacity: isInitialTableEmpty ? 0.6 : 1,
                            pointerEvents: isInitialTableEmpty
                              ? "none"
                              : "auto", // block actions
                            cursor: isInitialTableEmpty
                              ? "not-allowed"
                              : "pointer",
                            borderRadius: "8px"
                          }}
                        >
                          {filtersApplied && !isInitialTableEmpty ? (
                            <FilterActiveIcon />
                          ) : (
                            <FilterInactiveIcon />
                          )}
                        </button>
                        <FilterDrawer
                          isOpen={filterPopupOpen}
                          onClose={() => {
                            setTempValues({
                              status: [],
                              platforms: [],
                              platformPrice: [],
                              platformStock: [],
                            });
                            setFilterPopupOpen(false);
                          }}
                          sections={sections}
                          tempValues={tempValues}
                          setTempValues={setTempValues}
                          onApply={() => {
                            setFilters({
                              status: tempValues.status || [],
                              platforms: tempValues.platforms || [],
                              platformPrice: tempValues.platformPrice || [],
                              platformStock: tempValues.platformStock || [],
                            });
                            setFilterPopupOpen(false);
                          }}
                          onClear={() => {
                            const empty = {
                              status: [],
                              platforms: [],
                              platformPrice: [],
                              platformStock: [],
                            };

                            setTempValues(empty);
                            setFilters(empty);
                          }}
                        />
                      </div>
                    </div>

                    <div className="toolbar-right" ref={toolbarRef}>
                      {/* Flow-2 Start */}
                      {/* Bulk Pricing button with count (REPLACEMENT) */}
                      <div
                        style={{ position: "relative", border: "none" }}
                        ref={bulkToolbarRef}
                      >
                        <button
                          onClick={() => {
                            if (!bulkActive || bulkItems.length === 0) return;
                            setBulkDropdownOpen((prev) => !prev);
                          }}
                          disabled={!bulkActive || bulkItems.length === 0}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "6px 10px",
                            borderRadius: 8,
                            border: "none",
                            backgroundColor: "#ced4da", // dark background
                            color: "#fff", // white text
                            cursor:
                              bulkActive && bulkItems.length > 0
                                ? "pointer"
                                : "not-allowed",
                          }}
                        >
                          <PencilLine size={18} color="#fff" strokeWidth={2} />

                          <span
                            style={{
                              color: "#fff",
                              fontSize: 12,
                              fontWeight: 500,
                              paddingLeft:'7px'
                            }}
                          >
                            Bulk Pricing
                          </span>

                          <span
                            style={{
                              marginLeft: 6,
                              fontSize: 10,
                              color: "#fff",
                              transform: bulkDropdownOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.15s ease",
                              lineHeight:0.5
                            }}
                          >
                            ▼
                          </span>
                        </button>

                        {bulkDropdownOpen &&
                          bulkActive &&
                          bulkItems.length > 0 && (
                            <div
                              style={{
                                position: "absolute",
                                right: 0,
                                top: "48px",
                                zIndex: 1500,
                                minWidth: 400,
                              }}
                              className="bulk-dropdown-wrapper"
                            >
                              <div
                                className="bulk-dropdown"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: 5,
                                    paddingBottom: 15,
                                    borderBottom: "1px solid #E9ECEF",
                                  }}
                                >
                                  <div
                                    style={{ fontSize: 14, color: "#212529" }}
                                  >{`${bulkItems.length} Selected`}</div>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: 10,
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      className="bulk-clear-link"
                                      onClick={() => {
                                        clearSelection();
                                      }}
                                    >
                                      Clear
                                    </div>
                                    <button
                                      className="icon-btn"
                                      onClick={() => {
                                        history.push(
                                          "/listing-pricing/bulk-pricing"
                                        );
                                      }}
                                    >
                                      Start Pricing
                                    </button>
                                  </div>
                                </div>

                                {(() => {
                                  const bulkTotalPages = Math.max(
                                    1,
                                    Math.ceil(bulkItems.length / BULK_PAGE_SIZE)
                                  );
                                  const bulkPageData = bulkItems.slice(
                                    (bulkPage - 1) * BULK_PAGE_SIZE,
                                    bulkPage * BULK_PAGE_SIZE
                                  );

                                  return (
                                    <>
                                      <div>
                                        {bulkPageData.map((id) => {
                                          const opt = dummyData.find(
                                            (d) => d.id === id
                                          );
                                          if (!opt) return null;
                                          return (
                                            <div key={id} className="bulk-item">
                                              <div style={{ flex: 1 }}>
                                                <span className="bulk-item-title">
                                                  {opt.name}
                                                </span>
                                                <div className="bulk-item-sub">
                                                  <span
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "4px",
                                                      lineHeight: "normal",
                                                    }}
                                                  >
                                                    {String(opt.variant || "")
                                                      .split(",")[0]
                                                      .trim()}
                                                  </span>
                                                  <span
                                                    style={{ margin: "0 6px" }}
                                                  >
                                                    |
                                                  </span>
                                                  <span
                                                    style={{
                                                      background:
                                                        opt.condition === "New"
                                                          ? "#D1E7DD"
                                                          : "#FFF3CD",
                                                      border: `1px solid ${
                                                        opt.condition === "New"
                                                          ? "#198754"
                                                          : "#997404"
                                                      }`,
                                                      borderRadius: "100px",
                                                      fontSize: "10px",
                                                      fontWeight: 600,
                                                      color:
                                                        opt.condition === "New"
                                                          ? "#198754"
                                                          : "#997404",
                                                      padding: "1px 6px",
                                                      marginLeft: "4px",
                                                    }}
                                                  >
                                                    {opt.condition}
                                                  </span>
                                                  <span
                                                    style={{
                                                      color: "#6C757D",
                                                      marginLeft: 6,
                                                    }}
                                                  >
                                                    {opt.grading}
                                                  </span>
                                                </div>
                                              </div>

                                              <button
                                                onClick={() =>
                                                  removeBulkItem(id)
                                                }
                                                style={{
                                                  marginLeft: 12,
                                                  border: "none",
                                                  background: "transparent",
                                                  cursor: "pointer",
                                                }}
                                                aria-label={`Remove ${opt.name}`}
                                              >
                                                <X size={16} />
                                              </button>
                                            </div>
                                          );
                                        })}
                                      </div>

                                      <div
                                        className="pagination"
                                        style={{ marginTop: 16 }}
                                      >
                                        <div className="pagination-info">
                                          {`Showing ${
                                            (bulkPage - 1) * BULK_PAGE_SIZE + 1
                                          } - ${Math.min(
                                            bulkPage * BULK_PAGE_SIZE,
                                            bulkItems.length
                                          )} of ${bulkItems.length} items`}
                                        </div>

                                        <div
                                          className="pagination-controls"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                          }}
                                        >
                                          <button
                                            onClick={() =>
                                              setBulkPage((p) =>
                                                Math.max(1, p - 1)
                                              )
                                            }
                                            disabled={bulkPage === 1}
                                          >
                                            <ChevronLeft size={16} />
                                          </button>

                                          {[
                                            ...Array(
                                              Math.max(
                                                1,
                                                Math.ceil(
                                                  bulkItems.length /
                                                    BULK_PAGE_SIZE
                                                )
                                              )
                                            ),
                                          ].map((_, i) => (
                                            <button
                                              key={i}
                                              className={
                                                bulkPage === i + 1
                                                  ? "active"
                                                  : ""
                                              }
                                              onClick={() => setBulkPage(i + 1)}
                                            >
                                              {i + 1}
                                            </button>
                                          ))}

                                          <button
                                            onClick={() =>
                                              setBulkPage((p) =>
                                                Math.min(
                                                  Math.max(
                                                    1,
                                                    Math.ceil(
                                                      bulkItems.length /
                                                        BULK_PAGE_SIZE
                                                    )
                                                  ),
                                                  p + 1
                                                )
                                              )
                                            }
                                            disabled={
                                              bulkPage ===
                                              Math.ceil(
                                                bulkItems.length /
                                                  BULK_PAGE_SIZE
                                              )
                                            }
                                          >
                                            <ChevronRight size={16} />
                                          </button>
                                        </div>
                                      </div>
                                    </>
                                  );
                                })()}
                              </div>
                            </div>
                          )}
                      </div>
                      {/* Flow-2 End */}
                      {/* <button className="icon-btn dark-border"
                                                onClick={() => history.push("/listing-pricing/add-listing")}
                                            >
                                                <Plus size={18} /> Add Listing
                                            </button> */}
                    </div>
                  </div>

                  {/* Table */}
                  <div
                    className="table-wrapper"
                    style={{
                      borderBottom:
                        pageData.length === 0 || filtered.length === 0
                          ? "none"
                          : "1px solid #dee2e6",
                    }}
                  >
                    {pageData.length === 0 ? (
                      <div className="empty-state">
                        <div className="empty-state-content">
                          <div class="icon">
                            <img
                              src={noBrandImage}
                              alt="avatar"
                              className="avatar"
                              style={{
                                width: 120,
                                height: 120,
                                verticalAlign: "middle",
                              }}
                            />
                          </div>
                          <h1 class="no-item-title mt-2">No Listings Found for Pricing</h1>
                          <p class="no-item-text">
                            Add a Listing first to initiate Pricing
                          </p>
                        </div>
                      </div>
                    ) : filtered.length === 0 ? (
                      <div className="empty-state">
                        <div className="empty-state-content">
                          <div class="icon">
                            <img
                              src={emptySearchImg}
                              alt="avatar"
                              className="avatar"
                              style={{
                                width: 120,
                                height: 120,
                                verticalAlign: "middle",
                              }}
                            />
                          </div>
                          <h1 class="no-item-title mt-2">
                            No Categories Found
                          </h1>
                          <p class="no-item-text">
                            No results match what you're looking for
                          </p>
                        </div>
                      </div>
                    ) : (
                      <table className="entities-table">
                        <thead>
                          <tr>
                            {/* <th className="sticky-action-col first">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                checked={
                                                                    pageData.length > 0 &&
                                                                    pageData.every((d) => selectedIds.includes(d.id))
                                                                }
                                                                onChange={toggleAll}
                                                            />
                                                        </div>
                                                    </th> */}
                            {/* <th className="sticky-action-col"> */}
                            <SortableHeader
                              label="Stock"
                              field="name"
                              // sortConfig={sortConfig}
                              // onSortChange={onSortChange}
                            />
                            {/* </th> */}
                            <SortableHeader
                              label="Status"
                              field="status"
                              // sortConfig={sortConfig}
                              // onSortChange={onSortChange}
                            />
                            <SortableHeader
                              label="ID"
                              field="Id"
                              // sortConfig={sortConfig}
                              // onSortChange={onSortChange}
                            />
                            {/* <th>
                                                        <span>
                                                            Base Price <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th> */}
                            <th>
                              <span>Platforms</span>
                            </th>
                            <th>
                              <span>Platform Price</span>
                            </th>
                            {/* <th>
                                                        <span>
                                                            ERP Price <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th> */}
                            <th>
                              <span>Platform Stock</span>
                            </th>
                            {/* <th>
                                                        <span>
                                                            ERP Stock <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th> */}
                            <th>
                              <span>Last Sync Time</span>
                            </th>
                            <SortableHeader
                              label="Last Modiefied Time"
                              field="status"
                              // sortConfig={sortConfig}
                              // onSortChange={onSortChange}
                            />
                            <th
                              className="sticky-action-col"
                              style={{ textAlign: "center" }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {pageData.map((row, idx) => {
                            const isRowSelected =
                              (selectedIds.includes(row.id) ||
                                dropdownOpenId === row.id) &&
                              !suppressHighlight;

                            return (
                              <tr
                                key={row.id}
                                className={[
                                  idx % 2 ? "striped" : "",
                                  isRowSelected ? "row-selected" : "",
                                ].join(" ")}
                                onClick={() => onRowClick(row)}
                              >
                                {/* Checkbox cell */}
                                {/* <td onClick={(e) => e.stopPropagation()} className="sticky-action-col first">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={selectedIds.includes(row.id)}
                                                                        onChange={(e) => {
                                                                            toggleSelect(row.id);
                                                                            if (e.target.checked) {
                                                                                setSelectedRow(row);
                                                                            } else if (selectedRow?.id === row.id) {
                                                                                setSelectedRow(null);
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td> */}

                                {/* Stock */}
                                <td className="sticky-action-col">
                                  <div
                                    className="name-cell"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 10,
                                    }}
                                  >
                                    <img
                                      src={row.avatar}
                                      alt="avatar"
                                      className="avatar"
                                      style={{
                                        width: 40,
                                        height: 40,
                                        marginRight: 8,
                                        verticalAlign: "middle",
                                      }}
                                    />
                                    <div>
                                      <div>{row.name}</div>
                                      <div className="sub-line mt-1">
                                        {row.variant}
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 5,
                                          marginTop: 5,
                                        }}
                                      >
                                        {/* small badges like New / Activated */}
                                        <span
                                          className="status active"
                                          style={{
                                            minWidth: "unset",
                                            padding: "2px 8px",
                                            fontSize: "8px",
                                            lineHeight: "normal",
                                          }}
                                        >
                                          {row.condition}
                                        </span>
                                        <span className="sub-line m-0">
                                          {row.grading}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </td>

                                {/* Status */}
                                <td>
                                  <span
                                    className={`status ${
                                      row.status?.toLowerCase() ?? ""
                                    }`}
                                  >
                                    {row.status}
                                  </span>
                                </td>

                                {/* ID */}
                                <td>{row.iD}</td>

                                {/* Base Price */}
                                {/* <td>{row.basePrice}</td> */}

                                {/* Platforms - vertical aligned */}
                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 6,
                                    }}
                                  >
                                    {row.platforms.map((p, i) => {
                                      const textColor =
                                        mappedTextColorForPlatformColor(
                                          p.color
                                        );
                                      return (
                                        <div
                                          key={i}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                            fontSize: 13,
                                          }}
                                        >
                                          <span
                                            style={{
                                              color: p.color,
                                              fontSize: 14,
                                            }}
                                          >
                                            ●
                                          </span>
                                          <span
                                            style={
                                              textColor
                                                ? { color: textColor }
                                                : undefined
                                            }
                                          >
                                            {p.name}
                                          </span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </td>

                                {/* Platform Price */}
                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 6,
                                    }}
                                  >
                                    {row.platforms.map((p, i) => {
                                      const textColor =
                                        mappedTextColorForPlatformColor(
                                          p.color
                                        );
                                      return (
                                        <div
                                          key={i}
                                          style={
                                            textColor
                                              ? {
                                                  color: textColor,
                                                  fontSize: 13,
                                                }
                                              : { fontSize: 13 }
                                          }
                                        >
                                          {p.platformPrice}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </td>

                                {/* ERP Price */}
                                {/* <td>
                                                                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                                                    {row.platforms.map((p, i) => {
                                                                        const textColor = mappedTextColorForPlatformColor(p.color);
                                                                        return (
                                                                            <div key={i} style={textColor ? { color: textColor, fontSize: 13 } : { fontSize: 13 }}>
                                                                                {p.erpPrice}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </td> */}

                                {/* Platform Stock */}
                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 6,
                                    }}
                                  >
                                    {row.platforms.map((p, i) => {
                                      const textColor =
                                        mappedTextColorForPlatformColor(
                                          p.color
                                        );
                                      return (
                                        <div
                                          key={i}
                                          style={
                                            textColor
                                              ? {
                                                  color: textColor,
                                                  fontSize: 13,
                                                }
                                              : { fontSize: 13 }
                                          }
                                        >
                                          {p.platformStock}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </td>

                                {/* ERP Stock */}
                                {/* ID */}
                                {/* <td>{row.erpStock}</td> */}

                                {/* Last Sync Time */}
                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 6,
                                      fontSize: 13,
                                    }}
                                  >
                                    {row.platforms.map((p, i) => {
                                      const textColor =
                                        lastSyncTextColorForPlatformColor(
                                          p.color
                                        );
                                      return (
                                        <div
                                          key={i}
                                          style={{
                                            color: textColor ?? undefined,
                                          }}
                                        >
                                          {p.lastSync}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </td>

                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 6,
                                      fontSize: 13,
                                    }}
                                  >
                                    {row.lastSync}
                                  </div>
                                </td>

                                {/* Action */}
                                <td
                                  className="sticky-action-col"
                                  style={{ textAlign: "center" }}
                                >
                                  <button
                                    ref={(el) =>
                                      (buttonRefs.current[row.id] = el)
                                    }
                                    className="icon-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleDropdown(row.id);
                                      setDropdownOpenId(row.id);
                                      setSelectedRow(row);
                                    }}
                                  >
                                    <MoreHorizontal size={20} />
                                  </button>
                                </td>
                              </tr>
                            );
                          })}

                          {/* Fill empty rows to maintain consistent height if less than PAGE_SIZE */}
                          {/* {pageData.length < PAGE_SIZE &&
                                                    [...Array(PAGE_SIZE - pageData.length)].map((_, idx) => (
                                                        <tr key={`empty-${idx}`} className="empty-row" onClick={() => { }}>
                                                            <td colSpan={12}>&nbsp;</td>
                                                        </tr>
                                                    ))} */}
                        </tbody>
                      </table>
                    )}
                    {/* Per‐row dropdown menu */}
                    {dropdownOpenId !== null && (
                      <div
                        ref={dropdownRef}
                        className="backdrop-cls"
                        style={{
                          position: "absolute",
                          top: dropdownPosition.top,
                          left: dropdownPosition.left,
                          background: "white",
                          boxShadow: "0px 1px 4px 0px #0000001A",
                          zIndex: 1000,
                          minWidth: 152,
                          borderRadius: 8,
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="btn-align-forall">
                          <div className="common-for-all">
                            <button
                              onClick={() => {
                                alert("View Details clicked");
                                setDropdownOpenId(null); // 👈 Close dropdown
                              }}
                            >
                              View Details
                            </button>
                          </div>

                          <div className="common-for-all">
                            <button
                              // onClick={() => {
                              //     setSaveModalOpen(true);
                              //     setDropdownOpenId(null); // 👈 Close dropdown
                              // }}
                              onClick={() =>
                                history.push("/listing-pricing/edit-listing")
                              }
                            >
                              Edit
                            </button>
                          </div>

                          {/* Active / Deactivate */}
                          {/* ✅ Active / Deactivate */}
                          <div className="common-for-all">
                            {selectedRow.status === "Active" ? (
                              <button
                                onClick={() => {
                                  setSelectedStockId(selectedRow.id);
                                  setDeactivateModalOpen(true);
                                  setDropdownOpenId(null);
                                }}
                              >
                                Deactivate
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleDeactivateStock(selectedRow.id);
                                  setDropdownOpenId(null);
                                }}
                              >
                                Activate
                              </button>
                            )}
                          </div>

                          <div className="common-for-all">
                            <button
                              onClick={() => {
                                // setArchivedModalOpen(true);
                                setDropdownOpenId(null); // 👈 Close dropdown
                              }}
                              className="deactivate-cls"
                            >
                              Archive
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {showDuplicateWarning && (
                      <div
                        className="d-flex align-items-center justify-content-between"
                        role="alert"
                        style={{
                          boxShadow: "0px 4px 10px 0px #0000001F",
                          padding: "15px 10px",
                          borderRadius: "12px",
                          border: "1px solid #FFC107",
                          backgroundColor: "#FFF3CD",
                          color: "#664D03",
                          fontSize: "12px",
                          position: "fixed",
                          top: "10px",
                          width: "calc(100% - 20px)",
                          maxWidth: "610px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          zIndex: 2000,
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <Info className="me-2" />
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <strong>Duplicate entries weren’t added</strong> ——
                            All other items have been successfully added
                          </div>
                        </div>

                        <X
                          size={16}
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowDuplicateWarning(false)}
                        />
                      </div>
                    )}
                  </div>

                  {/* Pagination */}
                  {filtered.length > 0 && (
                    <div className="pagination" style={{ marginTop: 16 }}>
                      <div className="pagination-info">
                        {`${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(
                          currentPage * PAGE_SIZE,
                          filtered.length
                        )} of ${filtered.length} items`}
                      </div>
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  )}

                  {selectedIds.length > 0 && (
                    <div className="bottom-selection-bar">
                      <div className="bulk-count-bubble">
                        <div>{selectedIds.length} Selected</div>
                        <button
                          onClick={clearSelection}
                          title="Clear selection"
                        >
                          <X size={18} />
                        </button>
                      </div>

                      <div>
                        <button
                          onClick={handleAddToBulkPricing}
                          className="bulk-action-btn"
                        >
                          <Plus size={18} /> Add to Bulk Pricing
                        </button>
                      </div>
                    </div>
                  )}

                  {/* ------------------ Filter Drawer (RIGHT) ------------------ */}
                  {filterOpen && (
                    <>
                      <div
                        className="drawer-overlay"
                        onClick={() => {
                          // clicking backdrop should cancel (no apply)
                          setFilterOpen(false);
                        }}
                      />

                      <div
                        className="entity-drawer"
                        onClick={(e) => e.stopPropagation()}
                        style={{ maxWidth: "400px" }}
                      >
                        <div className="drawer-header">
                          <h3>Filter</h3>
                          <button
                            className="close-btn"
                            onClick={() => {
                              setFilterOpen(false);
                            }}
                          >
                            <X size={24} />
                          </button>
                        </div>
                        <div className="main-drawer-inner">
                          <div className="drawer-content">
                            <div className="tab-panel">
                              {/* Condition */}
                              <div className="field-block pt-0">
                                <div
                                  className="field-label"
                                  style={{ fontSize: 14, fontWeight: "600" }}
                                >
                                  Condition
                                </div>
                                {CONDITION_OPTIONS.map((opt) => (
                                  <label
                                    key={opt.key}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 8,
                                      padding: 10,
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      style={{ margin: 0 }}
                                      checked={(
                                        tempFilter.condition || []
                                      ).includes(opt.key)}
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        setTempFilter((prev) => {
                                          const setc = new Set(
                                            prev.condition || []
                                          );
                                          if (checked) setc.add(opt.key);
                                          else setc.delete(opt.key);
                                          return {
                                            ...prev,
                                            condition: Array.from(setc),
                                          };
                                        });
                                      }}
                                    />

                                    <div
                                      style={{
                                        display: "flex",
                                        gap: 8,
                                        alignItems: "center",
                                      }}
                                    >
                                      <span
                                        style={{
                                          background: opt.bg,
                                          border: `1px solid ${opt.border}`,
                                          borderRadius: 99,
                                          padding: "2px 10px",
                                          fontSize: 12,
                                          fontWeight: 600,
                                          color: opt.color,
                                          lineHeight: "normal",
                                        }}
                                      >
                                        {opt.label.split(" — ")[0]}
                                      </span>

                                      <div
                                        style={{
                                          fontSize: 14,
                                          fontWeight: 400,
                                          color: "#212529",
                                        }}
                                      >
                                        {opt.label.split(" — ")[1]}
                                      </div>
                                    </div>
                                  </label>
                                ))}
                              </div>
                              {/* Status */}
                              <div className="field-block">
                                <div
                                  className="field-label"
                                  style={{ fontSize: 14, fontWeight: "600" }}
                                >
                                  Status
                                </div>
                                {["Active", "Inactive"].map((s) => (
                                  <label
                                    key={s}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 8,
                                      padding: 10,
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      style={{ margin: 0 }}
                                      checked={tempFilter.status.includes(s)}
                                      onChange={(e) => {
                                        setTempFilter((prev) => {
                                          const set = new Set(prev.status);
                                          if (e.target.checked) set.add(s);
                                          else set.delete(s);
                                          return { ...prev, status: [...set] };
                                        });
                                      }}
                                    />
                                    <div
                                      style={{
                                        fontSize: 14,
                                        fontWeight: 400,
                                        color: "#212529",
                                      }}
                                    >
                                      {s}
                                    </div>
                                  </label>
                                ))}
                              </div>
                              {/* Base Price */}
                              <div className="field-block">
                                <div
                                  className="field-label"
                                  style={{ fontSize: 14, fontWeight: "600" }}
                                >
                                  Base Price
                                </div>
                                <div
                                  style={{ display: "flex", gap: 10 }}
                                  className="main-company-body-inner"
                                >
                                  <div>
                                    <label
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        color: "#212529",
                                      }}
                                    >
                                      Min
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control common-input-all"
                                      placeholder="Min"
                                      value={tempFilter.baseMin}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        setTempFilter((prev) => ({
                                          ...prev,
                                          baseMin: val,
                                        }));
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <label
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        color: "#212529",
                                      }}
                                    >
                                      Max
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control common-input-all"
                                      placeholder="Max"
                                      value={tempFilter.baseMax}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        setTempFilter((prev) => ({
                                          ...prev,
                                          baseMax: val,
                                        }));
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              {/* Platforms */}
                              <div className="field-block">
                                <div
                                  className="field-label"
                                  style={{ fontSize: 14, fontWeight: "600" }}
                                >
                                  Platforms
                                </div>
                                {["Shopee SG", "Lazada SG", "TikTok SG"].map(
                                  (pl) => (
                                    <label
                                      key={pl}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                        padding: 10,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        style={{ margin: 0 }}
                                        checked={tempFilter.platforms.includes(
                                          pl
                                        )}
                                        onChange={(e) => {
                                          setTempFilter((prev) => {
                                            const setp = new Set(
                                              prev.platforms || []
                                            );
                                            if (e.target.checked) setp.add(pl);
                                            else setp.delete(pl);
                                            return {
                                              ...prev,
                                              platforms: Array.from(setp),
                                            };
                                          });
                                        }}
                                      />
                                      <div
                                        style={{
                                          fontSize: 14,
                                          fontWeight: 400,
                                          color: "#212529",
                                        }}
                                      >
                                        {pl}
                                      </div>
                                    </label>
                                  )
                                )}
                              </div>
                              {/* ERP Stock */}
                              <div
                                className="field-block"
                                style={{ borderBottom: 0, paddingBottom: 50 }}
                              >
                                <div
                                  className="field-label"
                                  style={{ fontSize: 14, fontWeight: "600" }}
                                >
                                  ERP Stock
                                </div>
                                <div
                                  style={{ display: "flex", gap: 10 }}
                                  className="main-company-body-inner"
                                >
                                  {/* ERP Stock Min */}
                                  <div>
                                    <label
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        color: "#212529",
                                      }}
                                    >
                                      Min
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control common-input-all"
                                      placeholder="Min"
                                      value={tempFilter.erpMin}
                                      onChange={(e) => {
                                        const val = e.target.value; // <- capture value immediately
                                        setTempFilter((prev) => ({
                                          ...prev,
                                          erpMin: val,
                                        }));
                                      }}
                                    />
                                  </div>

                                  {/* ERP Stock Max */}
                                  <div>
                                    <label
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        color: "#212529",
                                      }}
                                    >
                                      Min
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control common-input-all"
                                      placeholder="Max"
                                      value={tempFilter.erpMax}
                                      onChange={(e) => {
                                        const val = e.target.value; // <- capture value immediately
                                        setTempFilter((prev) => ({
                                          ...prev,
                                          erpMax: val,
                                        }));
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              {/* Actions */}
                              <div className="field-block">
                                <div
                                  className="toolbar"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-end",
                                    gap: 10,
                                    marginTop: "auto",
                                  }}
                                >
                                  <button
                                    className="icon-btn"
                                    style={{ minWidth: 100 }}
                                    onClick={() => {
                                      // cancel -> restore temp to applied and close
                                      setTempFilter(
                                        appliedFilter || {
                                          condition: [],
                                          status: "",
                                          baseMin: "",
                                          baseMax: "",
                                          platforms: [],
                                          erpMin: "",
                                          erpMax: "",
                                        }
                                      );
                                      setFilterOpen(false);
                                    }}
                                  >
                                    Cancel
                                  </button>

                                  <button
                                    className="icon-btn dark-border"
                                    style={{ minWidth: 100 }}
                                    onClick={() => {
                                      // apply filter (if all empty we clear filters)
                                      const hasAny =
                                        (tempFilter.condition &&
                                          tempFilter.condition.length > 0) ||
                                        tempFilter.status ||
                                        tempFilter.baseMin ||
                                        tempFilter.baseMax ||
                                        (tempFilter.platforms &&
                                          tempFilter.platforms.length > 0) ||
                                        tempFilter.erpMin ||
                                        tempFilter.erpMax;

                                      setAppliedFilter(
                                        hasAny ? { ...tempFilter } : null
                                      );
                                      setFilterOpen(false);
                                      setCurrentPage(1);
                                    }}
                                  >
                                    Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/* ------------------ End Filter Drawer ------------------ */}

                  {/* Flow-2 End */}
                  {/* )} */}
                  {saveModalOpen && (
                    <>
                      <div className="drawer-overlay" />
                      <div
                        className="entity-drawer modal-popup-cls"
                        ref={saveRef}
                        style={{
                          maxWidth: 650,
                          margin: "0 auto",
                          background: "white",
                          borderRadius: 12,
                          zIndex: 1050,
                          padding: 24,
                          position: "fixed",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                          height: "auto",
                          right: "auto",
                          overflow: "inherit",
                        }}
                      >
                        <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                          <button
                            className="close-btn"
                            onClick={() => setSaveModalOpen(false)}
                          >
                            <X size={20} />
                          </button>
                        </div>
                        <h3
                          style={{
                            textAlign: "left",
                            color: "#212529",
                            fontSize: "20px",
                            fontWeight: "600",
                            lineHeight: "24px",
                            fontFamily: "Montserrat",
                            marginBottom: "5px",
                          }}
                        >
                          New feature in Progress
                        </h3>
                        <p
                          style={{
                            marginBottom: "0",
                            textAlign: "left",
                            color: "#6C757D",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            fontFamily: "Montserrat",
                          }}
                        >
                          Work in Progress
                        </p>
                        <div
                          className="drawer-footer"
                          style={{ paddingTop: "10px" }}
                        >
                          <button
                            className="btn-save"
                            onClick={handleSaveConfirm}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Single‐row Drawer (unchanged) */}
            {drawerOpen &&
              selectedRow &&
              (() => {
                const pendingCount =
                  selectedRow.pending?.reduce(
                    (sum, item) => sum + item.count,
                    0
                  ) || 0;
                const total = Number(selectedRow.available || 0) + pendingCount;
                return (
                  <>
                    <div className="drawer-overlay" />
                    <div className="entity-drawer" ref={drawerRef}>
                      <div className="drawer-header">
                        <h3>Listing Info</h3>
                        <button
                          className="close-btn"
                          onClick={() => {
                            setDrawerOpen(false);
                            setSelectedIds((ids) =>
                              ids.filter((id) => id !== selectedRow?.id)
                            );
                            setSelectedRow(null);
                          }}
                        >
                          <X size={24} />
                        </button>
                      </div>
                      <div className="main-drawer-inner">
                        <div className="drawer-title d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <img
                              src="https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
                              alt="avatar"
                              className="avatar"
                              style={{
                                width: 40,
                                height: 40,
                                marginRight: 8,
                                verticalAlign: "middle",
                              }}
                            />
                            <h2 className="pb-0">{selectedRow?.name}</h2>
                          </div>
                          <div className="entities-tab flex-row align-items-center gap-3">
                            <div class="main-company-body-inner">
                              <div class="edit-organisation-info d-flex justify-content-end align-items-center gap-2 p-0">
                                <button
                                  class="dark-border gray-btn"
                                  type="button"
                                  // onClick={() => setSaveModalOpen(true)}
                                  onClick={() =>
                                    history.push(
                                      "/listing-pricing/edit-listing"
                                    )
                                  }
                                >
                                  Edit
                                </button>
                              </div>
                            </div>
                            <div className="toolbar">
                              <div
                                className="toolbar-right"
                                style={{ position: "relative" }}
                                ref={toolbarRef}
                              >
                                <button
                                  className="drawer-dots"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleToolbarDropdown();
                                  }}
                                >
                                  <MoreHorizontal size={18} />
                                </button>

                                {toolbarDropdownOpen && (
                                  <div
                                    className="backdrop-cls"
                                    style={{
                                      position: "absolute",
                                      top: 40,
                                      right: 0,
                                      background: "white",
                                      boxShadow: "0px 1px 4px 0px #0000001A",
                                      zIndex: 1000,
                                      minWidth: 152,
                                      borderRadius: 8,
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <div className="btn-align-forall">
                                      <div className="common-for-all">
                                        <button
                                          onClick={() =>
                                            alert("Deactivate clicked")
                                          }
                                        >
                                          Deactivate
                                        </button>
                                      </div>
                                      <div className="common-for-all">
                                        <button className="deactivate-cls">
                                          Archive
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="drawer-tabs">
                          <button
                            className={
                              drawerTab === "entity-info" ? "active" : ""
                            }
                            onClick={() => setDrawerTab("entity-info")}
                          >
                            General
                          </button>
                          <button
                            className={drawerTab === "platform" ? "active" : ""}
                            onClick={() => setDrawerTab("platform")}
                          >
                            Platform
                          </button>
                          {/* <button
                                                    className={drawerTab === 'pricing' ? 'active' : ''}
                                                    onClick={() => setDrawerTab('pricing')}
                                                >
                                                    Pricing
                                                </button>
                                                <button
                                                    className={drawerTab === 'pricing-history' ? 'active' : ''}
                                                    onClick={() => setDrawerTab('pricing-history')}
                                                >
                                                    Pricing History
                                                </button> */}
                          <button
                            className={
                              drawerTab === "additional-info" ? "active" : ""
                            }
                            onClick={() => setDrawerTab("additional-info")}
                          >
                            Additional Info
                          </button>
                        </div>

                        <div className="drawer-content">
                          {drawerTab === "entity-info" && (
                            // <div className="tab-panel entity-info-panel">
                            //     <div className="field-block">
                            //         <div className="field-label">SPU & SKU</div>
                            //         <div className="field-value">
                            //             <a
                            //                 href="#"
                            //                 onClick={() => setSaveModalOpen(true)}
                            //                 rel="noopener noreferrer"
                            //                 className="d-flex align-items-center gap-1 me-3"
                            //                 style={{ color: '#2C7BE5', textDecoration: 'underline', fontWeight: '600', fontSize: '12px', marginBottom: '10px' }}
                            //             >
                            //                 {selectedRow.name}
                            //                 <SquareArrowOutUpRight size={14} strokeWidth={3} />
                            //             </a>
                            //         </div>
                            //         <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                            //             <span style={{ fontWeight: 600 }}>SKU:</span> {selectedRow.variant}
                            //         </div>
                            //         <div className="field-value" style={{ gap: '4px' }}>
                            //             <span style={{ fontWeight: 600 }}>Condition:</span> Brand {selectedRow.grading}
                            //             <span className="status active" style={{ minWidth: "unset", padding: "2px 10px", lineHeight: "normal" }}>
                            //                 {selectedRow.condition}
                            //             </span>
                            //         </div>
                            //     </div>

                            //     <div className="field-block">
                            //         <div className="field-label">Status</div>
                            //         <div className="field-value">
                            //             <span className={`status ${selectedRow.status.toLowerCase()}`}>
                            //                 {selectedRow.status}
                            //             </span>
                            //         </div>
                            //     </div>

                            //     <div className="field-block">
                            //         <div className="field-label">Open ID</div>
                            //         <div className="field-value d-flex align-items-center gap-2">
                            //             <span style={{ color: "#2C7BE5", cursor: "pointer", textDecoration: "underline" }} onClick={() => navigator.clipboard.writeText("8d5815b4-38d2-405c-86c0-3366fa7cbccc")}>
                            //                 8d5815b4-38d2-405c-86c0-3366fa7cbccc
                            //             </span>
                            //             <Copy size={13} onClick={() => navigator.clipboard.writeText("8d5815b4-38d2-405c-86c0-3366fa7cbccc")} style={{ cursor: "pointer", color: "#2C7BE5" }} />
                            //         </div>
                            //     </div>

                            //     <div className="field-block">
                            //         <div className="field-label">ID</div>
                            //         <div className="field-value">{selectedRow.iD}</div>
                            //     </div>
                            // </div>

                            <div className="tab-panel general-panel">
                              <div
                                className="card-section"
                                style={{
                                  borderRadius: "12px",
                                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)", // subtle elevation
                                  overflow: "hidden",
                                  marginBottom: "20px",
                                  marginTop: "15px",
                                }}
                              >
                                <div
                                  className="card-header"
                                  style={{
                                    backgroundColor: " #F8F9FA",
                                    padding: "15px 20px",
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: " #212529",
                                    display: "flex",
                                    alignItems: "center",
                                    alignSelf: "stretch",
                                    borderRadius: "12px 12px 0px 0px",
                                    gap: "10px",
                                    height: "50px",
                                    borderBottom: "none",
                                  }}
                                >
                                  Basic Info
                                </div>
                                {/* BODY */}
                                <div
                                  className="card-body"
                                  style={{
                                    backgroundColor: "#FFFFFF",
                                    padding: "16px",
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    gap: "16px",
                                  }}
                                >
                                  <div
                                    className="field-block"
                                    style={{
                                      borderBottom: "none",
                                      display: "flex",
                                      flexDirection: "column",
                                      minHeight: "60px",
                                      padding: "0",
                                    }}
                                  >
                                    <div className="field-label">SPU & SKU</div>
                                    <div className="field-value">
                                      <img
                                        src={selectedRow.avatar}
                                        alt="avatar"
                                        className="avatar"
                                        style={{
                                          width: 40,
                                          height: 40,
                                          marginRight: 8,
                                          verticalAlign: "middle",
                                        }}
                                      />
                                      <a
                                        href="#"
                                        onClick={() => setSaveModalOpen(true)}
                                        rel="noopener noreferrer"
                                        className="d-flex align-items-center gap-1 me-3"
                                        style={{
                                          color: "#2C7BE5",
                                          textDecoration: "underline",
                                          fontWeight: "600",
                                          fontSize: "12px",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        {selectedRow.name}
                                        <SquareArrowOutUpRight
                                          size={14}
                                          strokeWidth={3}
                                        />
                                      </a>
                                    </div>
                                    <div
                                      className="field-value"
                                      style={{
                                        marginBottom: "2px",
                                        gap: "4px",
                                      }}
                                    >
                                      {selectedRow.condition}
                                    </div>
                                    <div
                                      className="field-value"
                                      style={{ gap: "4px" }}
                                    >
                                      <span
                                        className="status active"
                                        style={{
                                          minWidth: "unset",
                                          padding: "2px 10px",
                                          lineHeight: "normal",
                                        }}
                                      >
                                        {selectedRow.grading}
                                      </span>
                                    </div>
                                  </div>

                                  <div
                                    className="field-block"
                                    style={{
                                      borderBottom: "none",
                                      display: "flex",
                                      flexDirection: "column",
                                      minHeight: "60px",
                                      padding: "0",
                                    }}
                                  >
                                    <div className="field-label">Status</div>
                                    <div className="field-value">
                                      <span
                                        className={`status ${String(
                                          selectedRow?.status || ""
                                        ).toLowerCase()}`}
                                      >
                                        {selectedRow?.status || (
                                          <span style={{ color: "#B0B0B0" }}>
                                            NA
                                          </span>
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    className="field-block"
                                    style={{
                                      borderBottom: "none",
                                      gridColumn: "1 / -1", // ✅ span both columns
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-start",
                                      // width: '100%',
                                      padding: "0",
                                    }}
                                  >
                                    <div
                                      className="field-label"
                                      style={{ marginBottom: "4px" }}
                                    >
                                      ID
                                    </div>
                                    <div
                                      className="field-value"
                                      style={{
                                        width: "100%",
                                        wordBreak: "break-all",
                                      }}
                                    >
                                      {selectedRow.model_id || (
                                        <span style={{ color: "#B0B0B0" }}>
                                          NA
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                  <div
                                    className="field-block"
                                    style={{
                                      borderBottom: "none",
                                      padding: "0",
                                      gridColumn: "1 / -1",
                                      display: "flex",
                                      flexDirection: "column",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      className="field-label"
                                      style={{ marginBottom: "4px" }}
                                    >
                                      Open ID
                                    </div>

                                    <div className="field-value cell-wrapper">
                                      {selectedRow.uuid ? (
                                        <div className="value-container">
                                          <span
                                            className="value-clickable"
                                            onClick={() =>
                                              handleCopy(selectedRow.uuid)
                                            }
                                          >
                                            {selectedRow.uuid}
                                          </span>
                                          <Copy
                                            size={13}
                                            className="copy-icon"
                                            onClick={() =>
                                              handleCopy(selectedRow.uuid)
                                            }
                                          />
                                          {copied && (
                                            <span className="copied-label">
                                              Copied!
                                            </span>
                                          )}
                                        </div>
                                      ) : (
                                        <span style={{ color: "#B0B0B0" }}>
                                          NA
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  <div
                                    className="field-block"
                                    style={{
                                      borderBottom: "none",
                                      padding: "0",
                                    }}
                                  >
                                    <div className="field-label">
                                      Created By
                                    </div>
                                    <div className="field-value">
                                      {selectedRow.created_by || (
                                        <span style={{ color: "#B0B0B0" }}>
                                          NA
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  <div
                                    className="field-block"
                                    style={{
                                      borderBottom: "none",
                                      padding: "0",
                                    }}
                                  >
                                    <div className="field-label">
                                      Created Time
                                    </div>
                                    <div className="field-value">
                                      {formatDateTime(
                                        selectedRow.created_at
                                      ) || (
                                        <span style={{ color: "#B0B0B0" }}>
                                          NA
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  <div
                                    className="field-block"
                                    style={{
                                      borderBottom: "none",
                                      padding: "0",
                                    }}
                                  >
                                    <div className="field-label">
                                      Last Modified By
                                    </div>
                                    <div className="field-value">
                                      {selectedRow.modified_by || (
                                        <span style={{ color: "#B0B0B0" }}>
                                          NA
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  <div
                                    className="field-block"
                                    style={{
                                      borderBottom: "none",
                                      padding: "0",
                                    }}
                                  >
                                    <div className="field-label">
                                      Last Modified Time
                                    </div>
                                    <div className="field-value">
                                      {formatDateTime(
                                        selectedRow.modified_at
                                      ) || (
                                        <span style={{ color: "#B0B0B0" }}>
                                          NA
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* ===== Product INFO CARD ===== */}
                            </div>
                          )}
                          {drawerTab === "platform" && (
                            <div className="tab-panel platform-panel">
                              <div
                                className="entities-tab"
                                style={{ padding: 0, paddingTop: "20px" }}
                              >
                                <div className="table-wrapper">
                                  <table
                                    className="entities-table"
                                    ref={tableRef}
                                  >
                                    <thead>
                                      <tr>
                                        <th>
                                          <span>Platform</span>
                                        </th>
                                        <th>
                                          <span>Platform Name</span>
                                        </th>
                                        <th>
                                          <span>SKU Name</span>
                                        </th>
                                        <th>
                                          <span>Platform Price </span>
                                        </th>
                                        <th>
                                          <span>Platform Stock </span>
                                        </th>
                                        <th>
                                          <span>Last Sync Time</span>
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {visiblePlatformRows.map((item, idx) => {
                                        const Icon = item.iconType
                                          ? ICON_MAP[item.iconType]
                                          : null;
                                        const color = item.textColor || null;
                                        const tdStyle = color
                                          ? { color }
                                          : undefined;

                                        return (
                                          <tr
                                            key={item.id ?? idx}
                                            className={
                                              idx % 2 === 1 ? "striped" : ""
                                            }
                                          >
                                            {/* Apply color on each td and also to inner spans */}
                                            <td style={tdStyle}>
                                              {Icon ? (
                                                <span
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                  }}
                                                >
                                                  <Icon
                                                    size={14}
                                                    stroke={color}
                                                    color={color}
                                                  />
                                                  <span style={tdStyle}>
                                                    {item.platform}
                                                  </span>
                                                </span>
                                              ) : (
                                                <span style={tdStyle}>
                                                  {item.platform}
                                                </span>
                                              )}
                                            </td>

                                            <td style={tdStyle}>
                                              <span style={tdStyle}>
                                                {item.product_id}
                                              </span>
                                            </td>

                                            <td style={tdStyle}>
                                              <span style={tdStyle}>
                                                {item.sku_id}
                                              </span>
                                            </td>

                                            <td style={tdStyle}>
                                              <span style={tdStyle}>
                                                {item.last_sync_time}
                                              </span>
                                            </td>
                                          </tr>
                                        );
                                      })}

                                      {visiblePlatformRows.length === 0 && (
                                        <tr>
                                          {/* table had 4 columns — use 4 for colSpan */}
                                          <td
                                            colSpan="4"
                                            className="py-3 text-center"
                                          >
                                            No results found.
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}

                          {drawerTab === "additional-info" && (
                            <div
                              className="card-section"
                              style={{
                                borderRadius: "12px",
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
                                overflow: "hidden",
                                marginTop: "40px",
                              }}
                            >
                              {/* ✅ Header: same style as Business Info */}
                              <div
                                className="card-header"
                                style={{
                                  backgroundColor: "#F8F9FA",
                                  padding: "10px 16px",
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  color: "#212529",
                                  borderBottom: "none",
                                }}
                              >
                                Notes
                              </div>

                              {/* ✅ Body: matches layout and spacing */}
                              <div
                                className="card-body"
                                style={{
                                  backgroundColor: "#FFFFFF",
                                  padding: "16px",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "12px",
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                  whiteSpace: "normal",
                                }}
                              >
                                <div
                                  className="field-block"
                                  style={{ padding: "0px" }}
                                >
                                  <div
                                    className="field-value"
                                    style={{
                                      background: "#FFFFFF",
                                      // padding: '8px 0',
                                      fontSize: "13px",
                                      color: selectedRow.notes
                                        ? "#212529"
                                        : "#ADB5BD",
                                      minHeight: "24px",
                                    }}
                                  >
                                    {selectedRow.notes || "NA"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })()}
            {deactivateModalOpen && (
              <ConfirmDeactivateModal
                isOpen={deactivateModalOpen}
                onCancel={() => setDeactivateModalOpen(false)}
                onConfirm={() => {
                  handleDeactivateStock(selectedStockId);
                  // setDeactivateModalOpen(false);
                }}
                entityName="Listing"
              />
            )}

            {archivedModalOpen && (
              <>
                {/* Overlay backdrop */}
                <div className="drawer-overlay" />

                <div
                  className="entity-drawer modal-popup-cls"
                  ref={archivedRef}
                  style={{
                    maxWidth: 650,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: 24,
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                    overflow: "inherit",
                  }}
                >
                  {/* Header */}
                  <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button
                      className="close-btn"
                      onClick={() => setArchivedModalOpen(false)}
                    >
                      <X size={20} />
                    </button>
                  </div>

                  <h3
                    style={{
                      textAlign: "left",
                      color: "#212529",
                      fontSize: "20px",
                      fontWeight: "600",
                      lineHeight: "24px",
                      fontFamily: "Montserrat",
                      marginBottom: "5px",
                    }}
                  >
                    Branch can’t be archived
                  </h3>
                  {/* Subtext */}
                  <p
                    style={{
                      marginBottom: "0",
                      textAlign: "left",
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    Branch stocked with items can’t be archived, clear stock
                    before archiving. Archive action is also subject to approval
                  </p>

                  {/* Footer */}
                  <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                    <button
                      className="btn-save"
                      onClick={handleArchivedConfirm}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {activeTab === "price-history" && (
          <div className="tab-content" id="price-history-content">
            <div className="info-section">
              <div className="info-card">
                <div className="info-header">
                  <h4 className="info-title">Price History</h4>
                </div>
                <div className="entities-tab">
                  {/* toolbar */}
                  <div className="toolbar">
                    <div className="toolbar-left">
                      <div className="search-box">
                        <Search size={18} />
                        <input
                          type="text"
                          placeholder="Search…"
                          value={phSearchTerm}
                          onChange={(e) => {
                            setPhSearchTerm(e.target.value);
                            setPhCurrentPage(1);
                          }}
                        />
                      </div>

                      {/* <button className="icon-btn">
                                                <Funnel size={16} /> Filter
                                            </button> */}
                    </div>
                  </div>

                  {/* table */}
                  <div className="table-wrapper">
                    <table className="entities-table">
                      <thead>
                        <tr>
                          <th>
                            <span>
                              Time <ChevronsUpDown size={10} />
                            </span>
                          </th>
                          <th>
                            <span>
                              Initiator <ChevronsUpDown size={10} />
                            </span>
                          </th>
                          <th>
                            <span>
                              Changes <ChevronsUpDown size={10} />
                            </span>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {phPageData.map((row, idx) => (
                          <tr
                            key={row.id}
                            className={idx % 2 === 1 ? "striped" : ""}
                            onClick={() => phOnRowClick(row)}
                          >
                            {/* Time */}
                            <td style={{ width: 200 }}>{row.time}</td>

                            {/* Initiator — uses your provided snippet pattern */}
                            <td style={{ width: 200 }}>
                              <div className="name-cell">
                                <img
                                  src={row.initiator?.avatar || noImage}
                                  alt="avatar"
                                  className="avatar"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = noImage;
                                  }}
                                  style={{
                                    width: 28,
                                    height: 28,
                                    borderRadius: "50%",
                                    marginRight: 8,
                                    verticalAlign: "middle",
                                  }}
                                />
                                {row.initiator?.brandName || "—"}
                              </div>
                            </td>

                            {/* Changes label only (no extra 'View' button) */}
                            <td style={{ width: 200 }}>
                              <span>Pricing Change ({row.changeCount})</span>
                            </td>
                          </tr>
                        ))}

                        {/* pad rows to keep consistent height */}
                        {phPageData.length < PAGE_SIZE &&
                          [...Array(PAGE_SIZE - phPageData.length)].map(
                            (_, i) => (
                              <tr key={`empty-${i}`} className="empty-row">
                                <td colSpan={3}>&nbsp;</td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>

                  {/* pagination */}
                  <div className="pagination" style={{ marginTop: 16 }}>
                    <div className="pagination-info">
                      {`Showing ${
                        (phCurrentPage - 1) * PAGE_SIZE + 1
                      } - ${Math.min(
                        phCurrentPage * PAGE_SIZE,
                        phFiltered.length
                      )} of ${phFiltered.length} items`}
                    </div>

                    <div className="pagination-controls">
                      <button
                        onClick={() =>
                          setPhCurrentPage((p) => Math.max(1, p - 1))
                        }
                        disabled={phCurrentPage === 1}
                      >
                        <ChevronLeft size={18} />
                      </button>

                      {[...Array(phTotalPages)].map((_, i) => (
                        <button
                          key={i}
                          className={phCurrentPage === i + 1 ? "active" : ""}
                          onClick={() => setPhCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </button>
                      ))}

                      <button
                        onClick={() =>
                          setPhCurrentPage((p) => Math.min(phTotalPages, p + 1))
                        }
                        disabled={phCurrentPage === phTotalPages}
                      >
                        <ChevronRight size={18} />
                      </button>
                    </div>
                  </div>

                  {/* Drawer — uses same class/structure as your existing drawer (not a centered modal) */}
                  {phDrawerOpen && phSelectedRow && (
                    <>
                      <div className="drawer-overlay" />
                      <div className="entity-drawer" ref={phDrawerRef}>
                        <div className="drawer-header">
                          <h3>Price History</h3>
                          <button
                            className="close-btn"
                            onClick={() => {
                              setPhDrawerOpen(false);
                              setPhSelectedRow(null);
                            }}
                          >
                            <X size={24} />
                          </button>
                        </div>

                        <div className="main-drawer-inner">
                          <div className="drawer-title d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <h2 className="pb-0">
                                Pricing Change ({phSelectedRow.changeCount})
                              </h2>
                            </div>
                          </div>

                          <div className="drawer-tabs">
                            <button
                              className={
                                phDrawerTab === "overview" ? "active" : ""
                              }
                              onClick={() => setPhDrawerTab("overview")}
                            >
                              Overview
                            </button>
                            <button
                              className={
                                phDrawerTab === "changes" ? "active" : ""
                              }
                              onClick={() => setPhDrawerTab("changes")}
                            >
                              Changes
                            </button>
                          </div>

                          <div className="drawer-content">
                            {/* Overview Tab: two fields from selected row + one fallback static only when reason not present */}
                            {phDrawerTab === "overview" && (
                              <div className="tab-panel entity-info-panel">
                                <div className="field-block">
                                  <div className="field-label">Time</div>
                                  <div className="field-value">
                                    {phSelectedRow.time}
                                  </div>
                                </div>

                                <div className="field-block">
                                  <div className="field-label">Initiator</div>
                                  <div className="field-value">
                                    {phSelectedRow.initiator?.brandName}
                                  </div>
                                </div>

                                <div className="field-block">
                                  <div className="field-label">Reason</div>
                                  <div className="field-value">
                                    {phSelectedRow.reason ??
                                      "Pricing Change (system)"}{" "}
                                    {/* fallback static only if reason missing */}
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Changes Tab: table of changes (pulled from selectedRow.changes) */}
                            {phDrawerTab === "changes" && (
                              <div className="tab-panel pricing-panel">
                                <div
                                  className="entities-tab"
                                  style={{ padding: 0, paddingTop: "20px" }}
                                >
                                  <div className="table-wrapper">
                                    <table className="entities-table">
                                      <thead>
                                        <tr>
                                          <th>
                                            <span>
                                              Stock <ChevronsUpDown size={12} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              Base Price{" "}
                                              <ChevronsUpDown size={12} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              Platform Price{" "}
                                              <ChevronsUpDown size={12} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              ERP Price{" "}
                                              <ChevronsUpDown size={12} />
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {sampleRows.map((item, idx) => (
                                          <tr
                                            key={item.id}
                                            className={
                                              idx % 2 === 1 ? "striped" : ""
                                            }
                                          >
                                            {/* Stock */}
                                            <td>
                                              <div
                                                className="name-cell"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 10,
                                                }}
                                              >
                                                <img
                                                  src={
                                                    item.avatar || safeNoImage
                                                  }
                                                  alt=""
                                                  style={{
                                                    width: 40,
                                                    height: 40,
                                                    marginRight: 8,
                                                  }}
                                                />
                                                <div>
                                                  <div>{item.name}</div>
                                                  <div className="sub-line mt-1">
                                                    {item.variant}
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: 6,
                                                      marginTop: 6,
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        background: "#D1E7DD",
                                                        color: "#198754",
                                                        border:
                                                          "1px solid #198754",
                                                        padding: "2px 8px",
                                                        fontSize: 8,
                                                        lineHeight: "normal",
                                                        borderRadius: 12,
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      {item.condition}
                                                    </span>
                                                    <span className="sub-line m-0">
                                                      {item.grading}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>

                                            {/* Base Price */}
                                            <td>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "6px",
                                                }}
                                              >
                                                <span style={{ fontSize: 14 }}>
                                                  {item.baseCurrent}
                                                </span>
                                                <Arrow />
                                                <PricePill
                                                  value={item.baseTarget}
                                                />
                                              </div>
                                            </td>

                                            {/* Platform Price */}
                                            <td>
                                              <PlatformList
                                                platforms={item.platforms}
                                              />
                                            </td>

                                            {/* ERP Price */}
                                            <td>
                                              <ErpList erp={item.erp} />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "archived-listing" && (
          <div className="tab-content" id="archived-listing-content">
            {/* Stock List Card */}
            <div className="info-section">
              <div className="info-card">
                <div className="info-header">
                  <h4 className="info-title">Archived Listing</h4>
                </div>

                <div className="entities-tab">
                  {/* Toolbar: Search + Filter on left; Edit/Plus on right */}
                  <div className="toolbar">
                    <div className="toolbar-left">
                      <div className="search-box">
                        <Search size={20} />
                        <input
                          type="text"
                          placeholder="Search…"
                          value={searchTermArchived}
                          onChange={(e) => {
                            setSearchTermArchived(e.target.value);
                            setCurrentPageArchived(1);
                          }}
                        />
                      </div>

                      {/* Archived: Filter button (opens right-hand drawer) */}
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <button
                          className="icon-btn"
                          onClick={() => {
                            setTempFilterArchived(
                              appliedFilterArchived || {
                                condition: [],
                                status: [],
                                baseMin: "",
                                baseMax: "",
                                platforms: [],
                                erpMin: "",
                                erpMax: "",
                              }
                            );
                            setFilterOpenArchived(true);
                          }}
                        >
                          <Funnel size={18} /> Filter
                          {filterCountArchived > 0 && (
                            <span
                              style={{
                                marginLeft: 6,
                                background: "#212529",
                                color: "#fff",
                                borderRadius: 999,
                                fontSize: 12,
                                fontWeight: 600,
                                width: 20,
                                height: 20,
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flex: "none",
                              }}
                            >
                              {filterCountArchived}
                            </span>
                          )}
                        </button>

                        {/* Reset only visible when we have applied filters */}
                        {appliedFilterArchived &&
                          Object.keys(appliedFilterArchived).length > 0 && (
                            <button
                              className="icon-btn dark-border"
                              onClick={() => {
                                setAppliedFilterArchived(null);
                                setFilterOpenArchived(false);
                                setCurrentPageArchived(1);
                              }}
                              title="Reset filters"
                            >
                              Reset
                            </button>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="table-wrapper">
                    <table className="entities-table">
                      <thead>
                        <tr>
                          {/* <th className="sticky-action-col first">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                checked={
                                                                    pageDataArchived.length > 0 &&
                                                                    pageDataArchived.every((d) => selectedIdsArchived.includes(d.id))
                                                                }
                                                                onChange={toggleAllArchived}
                                                            />
                                                        </div>
                                                    </th> */}

                          <th className="sticky-action-col first">
                            <span>
                              Stock <ChevronsUpDown size={12} />
                            </span>
                          </th>

                          <th>
                            <span>
                              ID <ChevronsUpDown size={12} />
                            </span>
                          </th>
                          <th>
                            <span>
                              Base Price <ChevronsUpDown size={12} />
                            </span>
                          </th>
                          <th>
                            <span>
                              Platforms <ChevronsUpDown size={12} />
                            </span>
                          </th>
                          <th>
                            <span>
                              Platform Price <ChevronsUpDown size={12} />
                            </span>
                          </th>
                          <th>
                            <span>
                              ERP Price <ChevronsUpDown size={12} />
                            </span>
                          </th>
                          <th>
                            <span>
                              Platform Stock <ChevronsUpDown size={12} />
                            </span>
                          </th>
                          <th>
                            <span>
                              ERP Stock <ChevronsUpDown size={12} />
                            </span>
                          </th>
                          <th>
                            <span>
                              Last Sync Time <ChevronsUpDown size={12} />
                            </span>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {pageDataArchived.map((row, idx) => {
                          const isRowSelected =
                            (selectedIdsArchived.includes(row.id) ||
                              dropdownOpenIdArchived === row.id) &&
                            !suppressHighlightArchived;

                          return (
                            <tr
                              key={row.id}
                              className={[
                                idx % 2 ? "striped" : "",
                                isRowSelected ? "row-selected" : "",
                              ].join(" ")}
                              onClick={() => onRowClickArchived(row)}
                            >
                              {/* <td onClick={(e) => e.stopPropagation()} className="sticky-action-col first">
                                                                <div className="form-check">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={selectedIdsArchived.includes(row.id)}
                                                                        onChange={(e) => {
                                                                            toggleSelectArchived(row.id);
                                                                            if (e.target.checked) {
                                                                                setSelectedRowArchived(row);
                                                                            } else if (selectedRowArchived?.id === row.id) {
                                                                                setSelectedRowArchived(null);
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td> */}

                              <td className="sticky-action-col first">
                                <div
                                  className="name-cell"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                  }}
                                >
                                  <img
                                    src={row.avatar}
                                    alt="avatar"
                                    className="avatar"
                                    style={{
                                      width: 40,
                                      height: 40,
                                      marginRight: 8,
                                      verticalAlign: "middle",
                                    }}
                                  />
                                  <div>
                                    <div>{row.name}</div>
                                    <div className="sub-line mt-1">
                                      {row.variant}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 5,
                                        marginTop: 5,
                                      }}
                                    >
                                      <span
                                        className="status active"
                                        style={{
                                          minWidth: "unset",
                                          padding: "2px 8px",
                                          fontSize: "8px",
                                          lineHeight: "normal",
                                        }}
                                      >
                                        {row.condition}
                                      </span>
                                      <span className="sub-line m-0">
                                        {row.grading}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <td>{row.iD}</td>
                              <td>{row.basePrice}</td>

                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 6,
                                  }}
                                >
                                  {row.platforms.map((p, i) => {
                                    const textColor =
                                      mappedTextColorForPlatformColor(p.color);
                                    return (
                                      <div
                                        key={i}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 8,
                                          fontSize: 13,
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: p.color,
                                            fontSize: 14,
                                          }}
                                        >
                                          ●
                                        </span>
                                        <span
                                          style={
                                            textColor
                                              ? { color: textColor }
                                              : undefined
                                          }
                                        >
                                          {p.name}
                                        </span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>

                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 6,
                                  }}
                                >
                                  {row.platforms.map((p, i) => {
                                    const textColor =
                                      mappedTextColorForPlatformColor(p.color);
                                    return (
                                      <div
                                        key={i}
                                        style={
                                          textColor
                                            ? { color: textColor, fontSize: 13 }
                                            : { fontSize: 13 }
                                        }
                                      >
                                        {p.platformPrice}
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>

                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 6,
                                  }}
                                >
                                  {row.platforms.map((p, i) => {
                                    const textColor =
                                      mappedTextColorForPlatformColor(p.color);
                                    return (
                                      <div
                                        key={i}
                                        style={
                                          textColor
                                            ? { color: textColor, fontSize: 13 }
                                            : { fontSize: 13 }
                                        }
                                      >
                                        {p.erpPrice}
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>

                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 6,
                                  }}
                                >
                                  {row.platforms.map((p, i) => {
                                    const textColor =
                                      mappedTextColorForPlatformColor(p.color);
                                    return (
                                      <div
                                        key={i}
                                        style={
                                          textColor
                                            ? { color: textColor, fontSize: 13 }
                                            : { fontSize: 13 }
                                        }
                                      >
                                        {p.platformStock}
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>

                              <td>{row.erpStock}</td>

                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 6,
                                    fontSize: 13,
                                  }}
                                >
                                  {row.platforms.map((p, i) => {
                                    const textColor =
                                      lastSyncTextColorForPlatformColor(
                                        p.color
                                      );
                                    return (
                                      <div
                                        key={i}
                                        style={{
                                          color: textColor ?? undefined,
                                        }}
                                      >
                                        {p.lastSync}
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>
                            </tr>
                          );
                        })}

                        {pageDataArchived.length < PAGE_SIZE &&
                          [...Array(PAGE_SIZE - pageDataArchived.length)].map(
                            (_, idx) => (
                              <tr
                                key={`empty-arch-${idx}`}
                                className="empty-row"
                                onClick={() => {}}
                              >
                                <td colSpan={12}>&nbsp;</td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                  </div>

                  {/* Archive pagination */}
                  <div className="pagination" style={{ marginTop: 16 }}>
                    <div className="pagination-info">
                      {`Showing ${
                        (currentPageArchived - 1) * PAGE_SIZE + 1
                      } - ${Math.min(
                        currentPageArchived * PAGE_SIZE,
                        filteredArchived.length
                      )} of ${filteredArchived.length} items`}
                    </div>

                    <div className="pagination-controls">
                      <button
                        onClick={() =>
                          setCurrentPageArchived((p) => Math.max(1, p - 1))
                        }
                        disabled={currentPageArchived === 1}
                      >
                        <ChevronLeft size={20} />
                      </button>

                      {[...Array(totalPagesArchived)].map((_, i) => (
                        <button
                          key={i}
                          className={
                            currentPageArchived === i + 1 ? "active" : ""
                          }
                          onClick={() => setCurrentPageArchived(i + 1)}
                        >
                          {i + 1}
                        </button>
                      ))}

                      <button
                        onClick={() =>
                          setCurrentPageArchived((p) =>
                            Math.min(totalPagesArchived, p + 1)
                          )
                        }
                        disabled={currentPageArchived === totalPagesArchived}
                      >
                        <ChevronRight size={20} />
                      </button>
                    </div>
                  </div>
                  {/* ------------------ Archive Filter Drawer (RIGHT) ------------------ */}
                  {filterOpenArchived && (
                    <>
                      <div
                        className="drawer-overlay"
                        onClick={() => {
                          // clicking backdrop should cancel (no apply)
                          setFilterOpenArchived(false);
                        }}
                      />

                      <div
                        className="entity-drawer"
                        onClick={(e) => e.stopPropagation()}
                        style={{ maxWidth: "400px" }}
                      >
                        <div className="drawer-header">
                          <h3>Filter</h3>
                          <button
                            className="close-btn"
                            onClick={() => {
                              setFilterOpenArchived(false);
                            }}
                          >
                            <X size={24} />
                          </button>
                        </div>

                        <div className="main-drawer-inner">
                          <div className="drawer-content">
                            <div className="tab-panel">
                              {/* Condition */}
                              <div className="field-block pt-0">
                                <div
                                  className="field-label"
                                  style={{ fontSize: 14, fontWeight: "600" }}
                                >
                                  Condition
                                </div>

                                {CONDITION_OPTIONS_ARCHIVED.map((key) => {
                                  const parts = String(key).split("|");
                                  const left = parts[0] || "";
                                  const right = parts[1] || "";
                                  const isNew = left
                                    .toLowerCase()
                                    .startsWith("new");

                                  return (
                                    <label
                                      key={key}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                        padding: 10,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        style={{ margin: 0 }}
                                        checked={(
                                          tempFilterArchived.condition || []
                                        ).includes(key)}
                                        onChange={(e) => {
                                          const checked = e.target.checked;
                                          setTempFilterArchived((prev) => {
                                            const setc = new Set(
                                              prev.condition || []
                                            );
                                            if (checked) setc.add(key);
                                            else setc.delete(key);
                                            return {
                                              ...prev,
                                              condition: Array.from(setc),
                                            };
                                          });
                                        }}
                                      />

                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 8,
                                          alignItems: "center",
                                        }}
                                      >
                                        <span
                                          style={{
                                            background: isNew
                                              ? "#D1E7DD"
                                              : "#FFF3CD",
                                            border: `1px solid ${
                                              isNew ? "#198754" : "#997404"
                                            }`,
                                            borderRadius: 99,
                                            padding: "2px 10px",
                                            fontSize: 12,
                                            fontWeight: 600,
                                            color: isNew
                                              ? "#198754"
                                              : "#997404",
                                            lineHeight: "normal",
                                          }}
                                        >
                                          {left}
                                        </span>

                                        <div
                                          style={{
                                            fontSize: 14,
                                            fontWeight: 400,
                                            color: "#212529",
                                          }}
                                        >
                                          {right}
                                        </div>
                                      </div>
                                    </label>
                                  );
                                })}
                              </div>

                              {/* Status */}
                              <div className="field-block">
                                <div
                                  className="field-label"
                                  style={{ fontSize: 14, fontWeight: "600" }}
                                >
                                  Status
                                </div>
                                {["Active", "Inactive"].map((s) => (
                                  <label
                                    key={s}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 8,
                                      padding: 10,
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      style={{ margin: 0 }}
                                      checked={(
                                        tempFilterArchived.status || []
                                      ).includes(s)}
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        setTempFilterArchived((prev) => {
                                          const set = new Set(
                                            prev.status || []
                                          );
                                          if (checked) set.add(s);
                                          else set.delete(s);
                                          return {
                                            ...prev,
                                            status: Array.from(set),
                                          };
                                        });
                                      }}
                                    />
                                    <div
                                      style={{
                                        fontSize: 14,
                                        fontWeight: 400,
                                        color: "#212529",
                                      }}
                                    >
                                      {s}
                                    </div>
                                  </label>
                                ))}
                              </div>

                              {/* Base Price */}
                              <div className="field-block">
                                <div
                                  className="field-label"
                                  style={{ fontSize: 14, fontWeight: "600" }}
                                >
                                  Base Price
                                </div>
                                <div
                                  style={{ display: "flex", gap: 10 }}
                                  className="main-company-body-inner"
                                >
                                  <div>
                                    <label
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        color: "#212529",
                                      }}
                                    >
                                      Min
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control common-input-all"
                                      placeholder="Min"
                                      value={tempFilterArchived.baseMin}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        setTempFilterArchived((prev) => ({
                                          ...prev,
                                          baseMin: val,
                                        }));
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <label
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        color: "#212529",
                                      }}
                                    >
                                      Max
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control common-input-all"
                                      placeholder="Max"
                                      value={tempFilterArchived.baseMax}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        setTempFilterArchived((prev) => ({
                                          ...prev,
                                          baseMax: val,
                                        }));
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Platforms */}
                              <div className="field-block">
                                <div
                                  className="field-label"
                                  style={{ fontSize: 14, fontWeight: "600" }}
                                >
                                  Platforms
                                </div>
                                {["Shopee SG", "Lazada SG", "TikTok SG"].map(
                                  (pl) => (
                                    <label
                                      key={pl}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                        padding: 10,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        style={{ margin: 0 }}
                                        checked={(
                                          tempFilterArchived.platforms || []
                                        ).includes(pl)}
                                        onChange={(e) => {
                                          const checked = e.target.checked;
                                          setTempFilterArchived((prev) => {
                                            const setp = new Set(
                                              prev.platforms || []
                                            );
                                            if (checked) setp.add(pl);
                                            else setp.delete(pl);
                                            return {
                                              ...prev,
                                              platforms: Array.from(setp),
                                            };
                                          });
                                        }}
                                      />
                                      <div
                                        style={{
                                          fontSize: 14,
                                          fontWeight: 400,
                                          color: "#212529",
                                        }}
                                      >
                                        {pl}
                                      </div>
                                    </label>
                                  )
                                )}
                              </div>

                              {/* ERP Stock */}
                              <div
                                className="field-block"
                                style={{ borderBottom: 0, paddingBottom: 50 }}
                              >
                                <div
                                  className="field-label"
                                  style={{ fontSize: 14, fontWeight: "600" }}
                                >
                                  ERP Stock
                                </div>
                                <div
                                  style={{ display: "flex", gap: 10 }}
                                  className="main-company-body-inner"
                                >
                                  {/* ERP Stock Min */}
                                  <div>
                                    <label
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        color: "#212529",
                                      }}
                                    >
                                      Min
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control common-input-all"
                                      placeholder="Min"
                                      value={tempFilterArchived.erpMin}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        setTempFilterArchived((prev) => ({
                                          ...prev,
                                          erpMin: val,
                                        }));
                                      }}
                                    />
                                  </div>

                                  {/* ERP Stock Max */}
                                  <div>
                                    <label
                                      style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        color: "#212529",
                                      }}
                                    >
                                      Max
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control common-input-all"
                                      placeholder="Max"
                                      value={tempFilterArchived.erpMax}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        setTempFilterArchived((prev) => ({
                                          ...prev,
                                          erpMax: val,
                                        }));
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Actions */}
                              <div className="field-block">
                                <div
                                  className="toolbar"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-end",
                                    gap: 10,
                                    marginTop: "auto",
                                  }}
                                >
                                  <button
                                    className="icon-btn"
                                    style={{ minWidth: 100 }}
                                    onClick={() => {
                                      // cancel -> restore temp to applied and close
                                      setTempFilterArchived(
                                        appliedFilterArchived || {
                                          condition: [],
                                          status: [],
                                          baseMin: "",
                                          baseMax: "",
                                          platforms: [],
                                          erpMin: "",
                                          erpMax: "",
                                        }
                                      );
                                      setFilterOpenArchived(false);
                                    }}
                                  >
                                    Cancel
                                  </button>

                                  <button
                                    className="icon-btn dark-border"
                                    style={{ minWidth: 100 }}
                                    onClick={() => {
                                      // apply filter (if all empty we clear filters)
                                      const hasAny =
                                        (tempFilterArchived.condition &&
                                          tempFilterArchived.condition.length >
                                            0) ||
                                        (tempFilterArchived.status &&
                                          tempFilterArchived.status.length >
                                            0) ||
                                        tempFilterArchived.baseMin ||
                                        tempFilterArchived.baseMax ||
                                        (tempFilterArchived.platforms &&
                                          tempFilterArchived.platforms.length >
                                            0) ||
                                        tempFilterArchived.erpMin ||
                                        tempFilterArchived.erpMax;

                                      setAppliedFilterArchived(
                                        hasAny
                                          ? { ...tempFilterArchived }
                                          : null
                                      );
                                      setFilterOpenArchived(false);
                                      setCurrentPageArchived(1);
                                    }}
                                  >
                                    Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {/* ------------------ End Archive Filter Drawer ------------------ */}

                  {/* )} */}
                  {saveModalOpen && (
                    <>
                      <div className="drawer-overlay" />
                      <div
                        className="entity-drawer modal-popup-cls"
                        ref={saveRef}
                        style={{
                          maxWidth: 650,
                          margin: "0 auto",
                          background: "white",
                          borderRadius: 12,
                          zIndex: 1050,
                          padding: 24,
                          position: "fixed",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                          height: "auto",
                          right: "auto",
                          overflow: "inherit",
                        }}
                      >
                        <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                          <button
                            className="close-btn"
                            onClick={() => setSaveModalOpen(false)}
                          >
                            <X size={20} />
                          </button>
                        </div>
                        <h3
                          style={{
                            textAlign: "left",
                            color: "#212529",
                            fontSize: "20px",
                            fontWeight: "600",
                            lineHeight: "24px",
                            fontFamily: "Montserrat",
                            marginBottom: "5px",
                          }}
                        >
                          New feature in Progress
                        </h3>
                        <p
                          style={{
                            marginBottom: "0",
                            textAlign: "left",
                            color: "#6C757D",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            fontFamily: "Montserrat",
                          }}
                        >
                          Work in Progress
                        </p>
                        <div
                          className="drawer-footer"
                          style={{ paddingTop: "10px" }}
                        >
                          <button
                            className="btn-save"
                            onClick={handleSaveConfirm}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Single‐row Drawer (unchanged) */}
            {drawerOpenArchived &&
              selectedRowArchived &&
              (() => {
                const pendingCount =
                  selectedRowArchived.pending?.reduce(
                    (sum, item) => sum + item.count,
                    0
                  ) || 0;
                const total =
                  Number(selectedRowArchived.available || 0) + pendingCount;
                return (
                  <>
                    <div className="drawer-overlay" />
                    <div className="entity-drawer" ref={drawerRefArchived}>
                      <div className="drawer-header">
                        <h3>Listing Info</h3>
                        <button
                          className="close-btn"
                          onClick={() => {
                            setDrawerOpenArchived(false);
                            setSelectedIdsArchived((ids) =>
                              ids.filter((id) => id !== selectedRowArchived?.id)
                            );
                            setSelectedRowArchived(null);
                          }}
                        >
                          <X size={24} />
                        </button>
                      </div>

                      <div className="main-drawer-inner">
                        <div className="drawer-title d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <img
                              src="https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
                              alt="avatar"
                              className="avatar"
                              style={{
                                width: 40,
                                height: 40,
                                marginRight: 8,
                                verticalAlign: "middle",
                              }}
                            />
                            <h2 className="pb-0">
                              {selectedRowArchived?.name}
                            </h2>
                          </div>

                          <div className="entities-tab flex-row align-items-center gap-3">
                            <div className="main-company-body-inner">
                              <div className="edit-organisation-info d-flex justify-content-end align-items-center gap-2 p-0">
                                <button
                                  className="dark-border gray-btn"
                                  type="button"
                                  // onClick={() => setSaveModalOpen(true)}
                                  onClick={() =>
                                    history.push(
                                      "/listing-pricing/edit-listing"
                                    )
                                  }
                                >
                                  Edit
                                </button>
                              </div>
                            </div>

                            <div className="toolbar">
                              <div
                                className="toolbar-right"
                                style={{ position: "relative" }}
                                ref={toolbarRefArchived}
                              >
                                <button
                                  className="drawer-dots"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleToolbarDropdownArchived();
                                  }}
                                >
                                  <MoreHorizontal size={18} />
                                </button>

                                {toolbarDropdownOpenArchived && (
                                  <div
                                    className="backdrop-cls"
                                    style={{
                                      position: "absolute",
                                      top: 40,
                                      right: 0,
                                      background: "white",
                                      boxShadow: "0px 1px 4px 0px #0000001A",
                                      zIndex: 1000,
                                      minWidth: 152,
                                      borderRadius: 8,
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <div className="btn-align-forall">
                                      <div className="common-for-all">
                                        <button
                                          onClick={() =>
                                            alert("Deactivate clicked")
                                          }
                                        >
                                          Deactivate
                                        </button>
                                      </div>
                                      <div className="common-for-all">
                                        <button className="deactivate-cls">
                                          Archive
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="drawer-tabs">
                          <button
                            className={
                              drawerTabArchived === "entity-info"
                                ? "active"
                                : ""
                            }
                            onClick={() => setDrawerTabArchived("entity-info")}
                          >
                            Stock Info
                          </button>
                          <button
                            className={
                              drawerTabArchived === "platform" ? "active" : ""
                            }
                            onClick={() => setDrawerTabArchived("platform")}
                          >
                            Platform
                          </button>
                          <button
                            className={
                              drawerTabArchived === "pricing" ? "active" : ""
                            }
                            onClick={() => setDrawerTabArchived("pricing")}
                          >
                            Pricing
                          </button>
                          <button
                            className={
                              drawerTabArchived === "pricing-history"
                                ? "active"
                                : ""
                            }
                            onClick={() =>
                              setDrawerTabArchived("pricing-history")
                            }
                          >
                            Pricing History
                          </button>
                          <button
                            className={
                              drawerTabArchived === "additional-info"
                                ? "active"
                                : ""
                            }
                            onClick={() =>
                              setDrawerTabArchived("additional-info")
                            }
                          >
                            Additional Info
                          </button>
                        </div>

                        <div className="drawer-content">
                          {drawerTabArchived === "entity-info" && (
                            <div className="tab-panel entity-info-panel">
                              <div className="field-block">
                                <div className="field-label">SPU &amp; SKU</div>
                                <div className="field-value">
                                  <a
                                    href="#"
                                    onClick={() => setSaveModalOpen(true)}
                                    rel="noopener noreferrer"
                                    className="d-flex align-items-center gap-1 me-3"
                                    style={{
                                      color: "#2C7BE5",
                                      textDecoration: "underline",
                                      fontWeight: "600",
                                      fontSize: "12px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    {selectedRowArchived.name}
                                    <SquareArrowOutUpRight
                                      size={14}
                                      strokeWidth={3}
                                    />
                                  </a>
                                </div>

                                <div
                                  className="field-value"
                                  style={{ marginBottom: "2px", gap: "4px" }}
                                >
                                  <span style={{ fontWeight: 600 }}>SKU:</span>{" "}
                                  {selectedRowArchived.variant}
                                </div>

                                <div
                                  className="field-value"
                                  style={{ gap: "4px" }}
                                >
                                  <span style={{ fontWeight: 600 }}>
                                    Condition:
                                  </span>{" "}
                                  Brand {selectedRowArchived.grading}
                                  <span
                                    className="status active"
                                    style={{
                                      minWidth: "unset",
                                      padding: "2px 10px",
                                      lineHeight: "normal",
                                    }}
                                  >
                                    {selectedRowArchived.condition}
                                  </span>
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">Status</div>
                                <div className="field-value">
                                  <span
                                    className={`status ${selectedRowArchived.status.toLowerCase()}`}
                                  >
                                    {selectedRowArchived.status}
                                  </span>
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">Open ID</div>
                                <div className="field-value d-flex align-items-center gap-2">
                                  <span
                                    style={{
                                      color: "#2C7BE5",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() =>
                                      navigator.clipboard.writeText(
                                        "8d5815b4-38d2-405c-86c0-3366fa7cbccc"
                                      )
                                    }
                                  >
                                    8d5815b4-38d2-405c-86c0-3366fa7cbccc
                                  </span>
                                  <Copy
                                    size={13}
                                    onClick={() =>
                                      navigator.clipboard.writeText(
                                        "8d5815b4-38d2-405c-86c0-3366fa7cbccc"
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      color: "#2C7BE5",
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">ID</div>
                                <div className="field-value">
                                  {selectedRowArchived.iD}
                                </div>
                              </div>
                            </div>
                          )}

                          {drawerTabArchived === "platform" && (
                            <div className="tab-panel platform-panel">
                              <div
                                className="entities-tab"
                                style={{ padding: 0, paddingTop: "20px" }}
                              >
                                <div className="table-wrapper">
                                  <table
                                    className="entities-table"
                                    ref={tableRefArchived}
                                  >
                                    <thead>
                                      <tr>
                                        <th>
                                          <span>
                                            Platform{" "}
                                            <ChevronsUpDown size={10} />
                                          </span>
                                        </th>
                                        <th>
                                          <span>
                                            Product ID{" "}
                                            <ChevronsUpDown size={10} />
                                          </span>
                                        </th>
                                        <th>
                                          <span>
                                            SKU ID <ChevronsUpDown size={12} />
                                          </span>
                                        </th>
                                        <th>
                                          <span>
                                            Last Sync Time{" "}
                                            <ChevronsUpDown size={12} />
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {visiblePlatformRows.map((item, idx) => {
                                        const Icon = item.iconType
                                          ? ICON_MAP[item.iconType]
                                          : null;
                                        const color = item.textColor || null;
                                        const tdStyle = color
                                          ? { color }
                                          : undefined;

                                        return (
                                          <tr
                                            key={item.id ?? idx}
                                            className={
                                              idx % 2 === 1 ? "striped" : ""
                                            }
                                          >
                                            <td style={tdStyle}>
                                              {Icon ? (
                                                <span
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                  }}
                                                >
                                                  <Icon
                                                    size={14}
                                                    stroke={color}
                                                    color={color}
                                                  />
                                                  <span style={tdStyle}>
                                                    {item.platform}
                                                  </span>
                                                </span>
                                              ) : (
                                                <span style={tdStyle}>
                                                  {item.platform}
                                                </span>
                                              )}
                                            </td>

                                            <td style={tdStyle}>
                                              <span style={tdStyle}>
                                                {item.product_id}
                                              </span>
                                            </td>
                                            <td style={tdStyle}>
                                              <span style={tdStyle}>
                                                {item.sku_id}
                                              </span>
                                            </td>
                                            <td style={tdStyle}>
                                              <span style={tdStyle}>
                                                {item.last_sync_time}
                                              </span>
                                            </td>
                                          </tr>
                                        );
                                      })}

                                      {visiblePlatformRows.length === 0 && (
                                        <tr>
                                          <td
                                            colSpan="4"
                                            className="py-3 text-center"
                                          >
                                            No results found.
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}

                          {drawerTabArchived === "pricing" && (
                            <div className="tab-panel pricing-panel">
                              <div
                                className="field-block"
                                style={{
                                  borderBottom: "0",
                                  paddingBottom: "0",
                                }}
                              >
                                <div className="field-label">Base Price</div>
                                <div className="field-value">
                                  {selectedRowArchived.basePrice}
                                </div>
                              </div>

                              <div
                                className="entities-tab"
                                style={{ padding: 0, paddingTop: "20px" }}
                              >
                                <div className="table-wrapper">
                                  <table
                                    className="entities-table"
                                    ref={tableRefArchived}
                                  >
                                    <thead>
                                      <tr>
                                        <th>
                                          <span>
                                            Platform{" "}
                                            <ChevronsUpDown size={10} />
                                          </span>
                                        </th>
                                        <th>
                                          <span>
                                            Listing Name{" "}
                                            <ChevronsUpDown size={10} />
                                          </span>
                                        </th>
                                        <th>
                                          <span>
                                            SKU Name{" "}
                                            <ChevronsUpDown size={12} />
                                          </span>
                                        </th>
                                        <th>
                                          <span>
                                            Platform Price{" "}
                                            <ChevronsUpDown size={12} />
                                          </span>
                                        </th>
                                        <th>
                                          <span>
                                            ERP Price{" "}
                                            <ChevronsUpDown size={12} />
                                          </span>
                                        </th>
                                        <th>
                                          <span>
                                            Platform Stock{" "}
                                            <ChevronsUpDown size={12} />
                                          </span>
                                        </th>
                                        <th>
                                          <span>
                                            ERP Stock{" "}
                                            <ChevronsUpDown size={12} />
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {visiblePricingRows.map((item, idx) => {
                                        const Icon = item.iconType
                                          ? ICON_MAP[item.iconType]
                                          : null;
                                        const color = item.textColor || null;
                                        const tdStyle = color
                                          ? { color }
                                          : undefined;

                                        return (
                                          <tr
                                            key={item.id ?? idx}
                                            className={
                                              idx % 2 === 1 ? "striped" : ""
                                            }
                                          >
                                            <td style={tdStyle}>
                                              {Icon ? (
                                                <span
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                  }}
                                                >
                                                  <Icon
                                                    size={14}
                                                    stroke={color}
                                                    color={color}
                                                  />
                                                  <span style={tdStyle}>
                                                    {item.platform}
                                                  </span>
                                                </span>
                                              ) : (
                                                <span style={tdStyle}>
                                                  {item.platform}
                                                </span>
                                              )}
                                            </td>

                                            <td
                                              style={{
                                                ...tdStyle,
                                                whiteSpace: "normal",
                                                maxWidth: "280px",
                                              }}
                                            >
                                              <span style={tdStyle}>
                                                {item.lising_name}
                                              </span>
                                            </td>

                                            <td
                                              style={{
                                                ...tdStyle,
                                                whiteSpace: "normal",
                                                maxWidth: "110px",
                                              }}
                                            >
                                              <span style={tdStyle}>
                                                {item.sku_name}
                                              </span>
                                            </td>

                                            <td style={tdStyle}>
                                              <span style={tdStyle}>
                                                {item.platform_price}
                                              </span>
                                            </td>
                                            <td style={tdStyle}>
                                              <span style={tdStyle}>
                                                {item.erp_price}
                                              </span>
                                            </td>
                                            <td style={tdStyle}>
                                              <span style={tdStyle}>
                                                {item.platform_stock}
                                              </span>
                                            </td>
                                            <td style={tdStyle}>
                                              <span style={tdStyle}>
                                                {item.erp_stock}
                                              </span>
                                            </td>
                                          </tr>
                                        );
                                      })}

                                      {visiblePricingRows.length === 0 && (
                                        <tr>
                                          <td
                                            colSpan="4"
                                            className="py-3 text-center"
                                          >
                                            No results found.
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}

                          {drawerTabArchived === "pricing-history" && (
                            <div className="tab-panel pricing-history-panel">
                              <div className="timeline">
                                {/* GROUP 1 — latest (filled dot) */}
                                <section className="group is-latest">
                                  <div className="date-row">
                                    <span className="dot" />
                                    <span className="date-text">
                                      2025-01-23
                                    </span>
                                  </div>

                                  <div className="card">
                                    <div className="row">
                                      <span className="time">12:30</span>
                                      <span className="actor">Ryan - Edit</span>
                                      <span className="field">Base Price</span>
                                      <span className="old">SGD 1,158.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 1,200.00</span>
                                    </div>

                                    <div className="row">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">Shopee</span>
                                      <span className="old">SGD 1,158.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 1,200.00</span>
                                    </div>

                                    <div className="row">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">Shopee</span>
                                      <span className="old">SGD 1,188.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 1,200.00</span>
                                    </div>

                                    <div className="row">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">Lazada</span>
                                      <span className="old">SGD 1,158.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 1,300.00</span>
                                    </div>

                                    <div className="row">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">Website</span>
                                      <span className="old">SGD 1,048.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 1,100.00</span>
                                    </div>

                                    <div className="row reason">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">
                                        Reason: Flash Sale
                                      </span>
                                    </div>
                                  </div>
                                </section>

                                {/* GROUP 2 — hollow dot */}
                                <section className="group">
                                  <div className="date-row">
                                    <span className="dot hollow" />
                                    <span className="date-text">
                                      2025-01-16
                                    </span>
                                  </div>

                                  <div className="card">
                                    <div className="row">
                                      <span className="time">12:30</span>
                                      <span className="actor">Ryan - Edit</span>
                                      <span className="field">Base Price</span>
                                      <span className="old">SGD 923.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 980.00</span>
                                    </div>
                                    <div className="row reason">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">
                                        Reason: Change in Cost Price
                                      </span>
                                    </div>
                                  </div>
                                </section>

                                {/* GROUP 3 — hollow dot */}
                                <section className="group">
                                  <div className="date-row">
                                    <span className="dot hollow" />
                                    <span className="date-text">
                                      2025-01-16
                                    </span>
                                  </div>

                                  <div className="card">
                                    <div className="row">
                                      <span className="time">12:30</span>
                                      <span className="actor">
                                        Ryan - Create
                                      </span>
                                      <span className="field">Listing</span>
                                      <span className="old"></span>
                                      <span className="arrow-placeholder"></span>
                                      <span className="new"></span>
                                    </div>

                                    <div className="row">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">Base Price</span>
                                      <span className="old">SGD 1,158.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 1,200.00</span>
                                    </div>

                                    <div className="row">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">Shopee</span>
                                      <span className="old">SGD 1,158.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 1,200.00</span>
                                    </div>

                                    <div className="row">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">Shopee</span>
                                      <span className="old">SGD 1,158.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 1,200.00</span>
                                    </div>

                                    <div className="row">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">Lazada</span>
                                      <span className="old">SGD 1,188.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 1,300.00</span>
                                    </div>

                                    <div className="row">
                                      <span className="time"></span>
                                      <span className="actor"></span>
                                      <span className="field">Lazada</span>
                                      <span className="old">SGD 1,048.00</span>
                                      <ArrowRight className="arrow" size={16} />
                                      <span className="new">SGD 1,100.00</span>
                                    </div>
                                  </div>
                                </section>
                              </div>
                            </div>
                          )}

                          {drawerTabArchived === "additional-info" && (
                            <div className="tab-panel additional-info-panel">
                              <p className="note-type-added">Note</p>
                              <label className="no-description-cls notes-preserve">
                                No Description
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })()}

            {archivedModalOpen && (
              <>
                {/* Overlay backdrop */}
                <div className="drawer-overlay" />

                <div
                  className="entity-drawer modal-popup-cls"
                  ref={archivedRef}
                  style={{
                    maxWidth: 650,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: 24,
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                    overflow: "inherit",
                  }}
                >
                  {/* Header */}
                  <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button
                      className="close-btn"
                      onClick={() => setArchivedModalOpen(false)}
                    >
                      <X size={20} />
                    </button>
                  </div>

                  <h3
                    style={{
                      textAlign: "left",
                      color: "#212529",
                      fontSize: "20px",
                      fontWeight: "600",
                      lineHeight: "24px",
                      fontFamily: "Montserrat",
                      marginBottom: "5px",
                    }}
                  >
                    Branch can’t be archived
                  </h3>
                  {/* Subtext */}
                  <p
                    style={{
                      marginBottom: "0",
                      textAlign: "left",
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    Branch stocked with items can’t be archived, clear stock
                    before archiving. Archive action is also subject to approval
                  </p>

                  {/* Footer */}
                  <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                    <button
                      className="btn-save"
                      onClick={handleArchivedConfirm}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
